/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedManagementRouteRouteImport } from './routes/_authenticated/_management/route'
import { Route as AuthenticatedAnordnungRouteRouteImport } from './routes/_authenticated/anordnung/route'
import { Route as AuthenticatedBarrierefreiheitRouteImport } from './routes/_authenticated/barrierefreiheit'
import { Route as AuthenticatedDatenschutzRouteImport } from './routes/_authenticated/datenschutz'
import { Route as AuthenticatedHilfeRouteRouteImport } from './routes/_authenticated/hilfe/route'
import { Route as AuthenticatedImpressumRouteImport } from './routes/_authenticated/impressum'
import { Route as AuthenticatedKontaktRouteImport } from './routes/_authenticated/kontakt'
import { Route as AuthenticatedNutzungsbedingungenRouteImport } from './routes/_authenticated/nutzungsbedingungen'
import { Route as AuthenticatedPruefungRouteRouteImport } from './routes/_authenticated/pruefung/route'
import { Route as AuthenticatedRegistrierungRouteImport } from './routes/_authenticated/registrierung'
import { Route as AuthenticatedManagementAdministrationRouteRouteImport } from './routes/_authenticated/_management/administration/route'
import { Route as AuthenticatedManagementMeineOrganisationRouteRouteImport } from './routes/_authenticated/_management/meine-organisation/route'
import { Route as AuthenticatedManagementVerkehrszeichenRouteRouteImport } from './routes/_authenticated/_management/verkehrszeichen/route'
import { Route as AuthenticatedManagementVorgaengeRouteRouteImport } from './routes/_authenticated/_management/vorgaenge/route'
import { Route as AuthenticatedAnordnungProcessIdRouteImport } from './routes/_authenticated/anordnung/$processId'
import { Route as AuthenticatedAnordnungSuccessRouteImport } from './routes/_authenticated/anordnung/success'
import { Route as AuthenticatedHilfeIndexRouteImport } from './routes/_authenticated/hilfe/index'
import { Route as AuthenticatedHilfeBenutzerverwaltungRouteImport } from './routes/_authenticated/hilfe/benutzerverwaltung'
import { Route as AuthenticatedHilfeDatenschnittstellenRouteImport } from './routes/_authenticated/hilfe/datenschnittstellen'
import { Route as AuthenticatedHilfeFunktionsuebersichtRouteImport } from './routes/_authenticated/hilfe/funktionsuebersicht'
import { Route as AuthenticatedHilfeKlickanleitungenRouteImport } from './routes/_authenticated/hilfe/klickanleitungen'
import { Route as AuthenticatedHilfeOrganisationsverwaltungRouteImport } from './routes/_authenticated/hilfe/organisationsverwaltung'
import { Route as AuthenticatedHilfeReleaseNotesRouteImport } from './routes/_authenticated/hilfe/release-notes'
import { Route as AuthenticatedHilfeVerkehrszeichenDatenmodellRouteImport } from './routes/_authenticated/hilfe/verkehrszeichen-datenmodell'
import { Route as AuthenticatedHilfeVerkehrszeichenEditRouteImport } from './routes/_authenticated/hilfe/verkehrszeichen-edit'
import { Route as AuthenticatedHilfeVorgaengeRouteImport } from './routes/_authenticated/hilfe/vorgaenge'
import { Route as AuthenticatedManagementAdministrationBenutzerinnenRouteRouteImport } from './routes/_authenticated/_management/administration/benutzerinnen/route'
import { Route as AuthenticatedManagementAdministrationOrganisationenRouteRouteImport } from './routes/_authenticated/_management/administration/organisationen/route'
import { Route as AuthenticatedManagementAdministrationPruefroutinenRouteRouteImport } from './routes/_authenticated/_management/administration/pruefroutinen/route'
import { Route as AuthenticatedManagementProfilIndexRouteImport } from './routes/_authenticated/_management/profil/index'
import { Route as AuthenticatedManagementProfilEditRouteImport } from './routes/_authenticated/_management/profil/edit'
import { Route as AuthenticatedManagementVerkehrszeichenIndexRouteImport } from './routes/_authenticated/_management/verkehrszeichen/index'
import { Route as AuthenticatedManagementVerkehrszeichenAdminLevelIdRouteImport } from './routes/_authenticated/_management/verkehrszeichen/$adminLevelId'
import { Route as AuthenticatedManagementVorgaengeIndexRouteImport } from './routes/_authenticated/_management/vorgaenge/index'
import { Route as AuthenticatedPruefungProcessIdExaminationIdRouteImport } from './routes/_authenticated/pruefung/$processId.$examinationId'
import { Route as AuthenticatedManagementAdministrationBenutzerinnenIndexRouteImport } from './routes/_authenticated/_management/administration/benutzerinnen/index'
import { Route as AuthenticatedManagementAdministrationBenutzerinnenUserIdRouteImport } from './routes/_authenticated/_management/administration/benutzerinnen/$userId'
import { Route as AuthenticatedManagementAdministrationOrganisationenIndexRouteImport } from './routes/_authenticated/_management/administration/organisationen/index'
import { Route as AuthenticatedManagementAdministrationOrganisationenHinzufuegenRouteImport } from './routes/_authenticated/_management/administration/organisationen/hinzufuegen'
import { Route as AuthenticatedManagementAdministrationPruefroutinenIndexRouteImport } from './routes/_authenticated/_management/administration/pruefroutinen/index'
import { Route as AuthenticatedManagementAdministrationVerwaltungsebenenIndexRouteImport } from './routes/_authenticated/_management/administration/verwaltungsebenen/index'
import { Route as AuthenticatedManagementMeineOrganisationBenutzerinnenIndexRouteImport } from './routes/_authenticated/_management/meine-organisation/benutzerinnen/index'
import { Route as AuthenticatedManagementMeineOrganisationBenutzerinnenUserIdRouteImport } from './routes/_authenticated/_management/meine-organisation/benutzerinnen/$userId'
import { Route as AuthenticatedManagementMeineOrganisationImporteIndexRouteImport } from './routes/_authenticated/_management/meine-organisation/importe/index'
import { Route as AuthenticatedManagementMeineOrganisationStakeholderIndexRouteImport } from './routes/_authenticated/_management/meine-organisation/stakeholder/index'
import { Route as AuthenticatedManagementMeineOrganisationStammdatenIndexRouteImport } from './routes/_authenticated/_management/meine-organisation/stammdaten/index'
import { Route as AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdRouteImport } from './routes/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId'
import { Route as AuthenticatedManagementVerkehrszeichenAdminLevelIdHinzufuegenRouteImport } from './routes/_authenticated/_management/verkehrszeichen/$adminLevelId/hinzufuegen'
import { Route as AuthenticatedManagementVerkehrszeichenRechercheIndexRouteImport } from './routes/_authenticated/_management/verkehrszeichen/recherche/index'
import { Route as AuthenticatedManagementVerkehrszeichenRechercheSignSupportIdRouteImport } from './routes/_authenticated/_management/verkehrszeichen/recherche/$signSupportId'
import { Route as AuthenticatedManagementVorgaengeAdminLevelIdIndexRouteImport } from './routes/_authenticated/_management/vorgaenge/$adminLevelId/index'
import { Route as AuthenticatedManagementVorgaengeRechercheIndexRouteImport } from './routes/_authenticated/_management/vorgaenge/recherche/index'
import { Route as AuthenticatedManagementAdministrationOrganisationenOrganizationIdIndexRouteImport } from './routes/_authenticated/_management/administration/organisationen/$organizationId/index'
import { Route as AuthenticatedManagementAdministrationVerwaltungsebenenAdminLevelIdIndexRouteImport } from './routes/_authenticated/_management/administration/verwaltungsebenen/$adminLevelId/index'
import { Route as AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdBearbeitenRouteImport } from './routes/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId.bearbeiten'
import { Route as AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdHinzufuegenRouteImport } from './routes/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId.hinzufuegen'
import { Route as AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdRouteImport } from './routes/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId_.$signGroupId'
import { Route as AuthenticatedManagementVerkehrszeichenRechercheSignSupportIdSignGroupIdRouteImport } from './routes/_authenticated/_management/verkehrszeichen/recherche/$signSupportId_.$signGroupId'
import { Route as AuthenticatedManagementVorgaengeAdminLevelIdProcessIdIndexRouteImport } from './routes/_authenticated/_management/vorgaenge/$adminLevelId/$processId/index'
import { Route as AuthenticatedManagementVorgaengeAdminLevelIdProcessIdExaminationIdRouteImport } from './routes/_authenticated/_management/vorgaenge/$adminLevelId/$processId/$examinationId'
import { Route as AuthenticatedManagementVorgaengeAdminLevelIdProcessIdEditRouteImport } from './routes/_authenticated/_management/vorgaenge/$adminLevelId/$processId/edit'
import { Route as AuthenticatedManagementVorgaengeAdminLevelIdKarteIndexRouteImport } from './routes/_authenticated/_management/vorgaenge/$adminLevelId/karte/index'
import { Route as AuthenticatedManagementAdministrationBenutzerinnenUserIdOrganisationHinzufuegenRouteImport } from './routes/_authenticated/_management/administration/benutzerinnen/$userId_.organisation.hinzufuegen'
import { Route as AuthenticatedManagementAdministrationOrganisationenOrganizationIdBenutzerinnenUserIdRouteImport } from './routes/_authenticated/_management/administration/organisationen/$organizationId/benutzerinnen.$userId'
import { Route as AuthenticatedManagementAdministrationOrganisationenOrganizationIdVerwaltungsebenenAdminLevelIdRouteImport } from './routes/_authenticated/_management/administration/organisationen/$organizationId/verwaltungsebenen.$adminLevelId'
import { Route as AuthenticatedManagementAdministrationVerwaltungsebenenAdminLevelIdOrganisationenHinzufuegenRouteImport } from './routes/_authenticated/_management/administration/verwaltungsebenen/$adminLevelId/organisationen.hinzufuegen'
import { Route as AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdBearbeitenRouteImport } from './routes/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId_.$signGroupId.bearbeiten'
import { Route as AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdDuplizierenRouteImport } from './routes/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId_.$signGroupId.duplizieren'
import { Route as AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdHinzufuegenRouteImport } from './routes/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId_.$signGroupId.hinzufuegen'
import { Route as AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdSignIdRouteImport } from './routes/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId_.$signGroupId_.$signId'
import { Route as AuthenticatedManagementVerkehrszeichenRechercheSignSupportIdSignGroupIdSignIdRouteImport } from './routes/_authenticated/_management/verkehrszeichen/recherche/$signSupportId_.$signGroupId_.$signId'
import { Route as AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdSignIdBearbeitenRouteImport } from './routes/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId_.$signGroupId_.$signId.bearbeiten'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedManagementRouteRoute =
  AuthenticatedManagementRouteRouteImport.update({
    id: '/_management',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAnordnungRouteRoute =
  AuthenticatedAnordnungRouteRouteImport.update({
    id: '/anordnung',
    path: '/anordnung',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBarrierefreiheitRoute =
  AuthenticatedBarrierefreiheitRouteImport.update({
    id: '/barrierefreiheit',
    path: '/barrierefreiheit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDatenschutzRoute =
  AuthenticatedDatenschutzRouteImport.update({
    id: '/datenschutz',
    path: '/datenschutz',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedHilfeRouteRoute = AuthenticatedHilfeRouteRouteImport.update({
  id: '/hilfe',
  path: '/hilfe',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedImpressumRoute = AuthenticatedImpressumRouteImport.update({
  id: '/impressum',
  path: '/impressum',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedKontaktRoute = AuthenticatedKontaktRouteImport.update({
  id: '/kontakt',
  path: '/kontakt',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedNutzungsbedingungenRoute =
  AuthenticatedNutzungsbedingungenRouteImport.update({
    id: '/nutzungsbedingungen',
    path: '/nutzungsbedingungen',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPruefungRouteRoute =
  AuthenticatedPruefungRouteRouteImport.update({
    id: '/pruefung',
    path: '/pruefung',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedRegistrierungRoute =
  AuthenticatedRegistrierungRouteImport.update({
    id: '/registrierung',
    path: '/registrierung',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedManagementAdministrationRouteRoute =
  AuthenticatedManagementAdministrationRouteRouteImport.update({
    id: '/administration',
    path: '/administration',
    getParentRoute: () => AuthenticatedManagementRouteRoute,
  } as any)
const AuthenticatedManagementMeineOrganisationRouteRoute =
  AuthenticatedManagementMeineOrganisationRouteRouteImport.update({
    id: '/meine-organisation',
    path: '/meine-organisation',
    getParentRoute: () => AuthenticatedManagementRouteRoute,
  } as any)
const AuthenticatedManagementVerkehrszeichenRouteRoute =
  AuthenticatedManagementVerkehrszeichenRouteRouteImport.update({
    id: '/verkehrszeichen',
    path: '/verkehrszeichen',
    getParentRoute: () => AuthenticatedManagementRouteRoute,
  } as any)
const AuthenticatedManagementVorgaengeRouteRoute =
  AuthenticatedManagementVorgaengeRouteRouteImport.update({
    id: '/vorgaenge',
    path: '/vorgaenge',
    getParentRoute: () => AuthenticatedManagementRouteRoute,
  } as any)
const AuthenticatedAnordnungProcessIdRoute =
  AuthenticatedAnordnungProcessIdRouteImport.update({
    id: '/$processId',
    path: '/$processId',
    getParentRoute: () => AuthenticatedAnordnungRouteRoute,
  } as any)
const AuthenticatedAnordnungSuccessRoute =
  AuthenticatedAnordnungSuccessRouteImport.update({
    id: '/success',
    path: '/success',
    getParentRoute: () => AuthenticatedAnordnungRouteRoute,
  } as any)
const AuthenticatedHilfeIndexRoute = AuthenticatedHilfeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedHilfeRouteRoute,
} as any)
const AuthenticatedHilfeBenutzerverwaltungRoute =
  AuthenticatedHilfeBenutzerverwaltungRouteImport.update({
    id: '/benutzerverwaltung',
    path: '/benutzerverwaltung',
    getParentRoute: () => AuthenticatedHilfeRouteRoute,
  } as any)
const AuthenticatedHilfeDatenschnittstellenRoute =
  AuthenticatedHilfeDatenschnittstellenRouteImport.update({
    id: '/datenschnittstellen',
    path: '/datenschnittstellen',
    getParentRoute: () => AuthenticatedHilfeRouteRoute,
  } as any)
const AuthenticatedHilfeFunktionsuebersichtRoute =
  AuthenticatedHilfeFunktionsuebersichtRouteImport.update({
    id: '/funktionsuebersicht',
    path: '/funktionsuebersicht',
    getParentRoute: () => AuthenticatedHilfeRouteRoute,
  } as any)
const AuthenticatedHilfeKlickanleitungenRoute =
  AuthenticatedHilfeKlickanleitungenRouteImport.update({
    id: '/klickanleitungen',
    path: '/klickanleitungen',
    getParentRoute: () => AuthenticatedHilfeRouteRoute,
  } as any)
const AuthenticatedHilfeOrganisationsverwaltungRoute =
  AuthenticatedHilfeOrganisationsverwaltungRouteImport.update({
    id: '/organisationsverwaltung',
    path: '/organisationsverwaltung',
    getParentRoute: () => AuthenticatedHilfeRouteRoute,
  } as any)
const AuthenticatedHilfeReleaseNotesRoute =
  AuthenticatedHilfeReleaseNotesRouteImport.update({
    id: '/release-notes',
    path: '/release-notes',
    getParentRoute: () => AuthenticatedHilfeRouteRoute,
  } as any)
const AuthenticatedHilfeVerkehrszeichenDatenmodellRoute =
  AuthenticatedHilfeVerkehrszeichenDatenmodellRouteImport.update({
    id: '/verkehrszeichen-datenmodell',
    path: '/verkehrszeichen-datenmodell',
    getParentRoute: () => AuthenticatedHilfeRouteRoute,
  } as any)
const AuthenticatedHilfeVerkehrszeichenEditRoute =
  AuthenticatedHilfeVerkehrszeichenEditRouteImport.update({
    id: '/verkehrszeichen-edit',
    path: '/verkehrszeichen-edit',
    getParentRoute: () => AuthenticatedHilfeRouteRoute,
  } as any)
const AuthenticatedHilfeVorgaengeRoute =
  AuthenticatedHilfeVorgaengeRouteImport.update({
    id: '/vorgaenge',
    path: '/vorgaenge',
    getParentRoute: () => AuthenticatedHilfeRouteRoute,
  } as any)
const AuthenticatedManagementAdministrationBenutzerinnenRouteRoute =
  AuthenticatedManagementAdministrationBenutzerinnenRouteRouteImport.update({
    id: '/benutzerinnen',
    path: '/benutzerinnen',
    getParentRoute: () => AuthenticatedManagementAdministrationRouteRoute,
  } as any)
const AuthenticatedManagementAdministrationOrganisationenRouteRoute =
  AuthenticatedManagementAdministrationOrganisationenRouteRouteImport.update({
    id: '/organisationen',
    path: '/organisationen',
    getParentRoute: () => AuthenticatedManagementAdministrationRouteRoute,
  } as any)
const AuthenticatedManagementAdministrationPruefroutinenRouteRoute =
  AuthenticatedManagementAdministrationPruefroutinenRouteRouteImport.update({
    id: '/pruefroutinen',
    path: '/pruefroutinen',
    getParentRoute: () => AuthenticatedManagementAdministrationRouteRoute,
  } as any)
const AuthenticatedManagementProfilIndexRoute =
  AuthenticatedManagementProfilIndexRouteImport.update({
    id: '/profil/',
    path: '/profil/',
    getParentRoute: () => AuthenticatedManagementRouteRoute,
  } as any)
const AuthenticatedManagementProfilEditRoute =
  AuthenticatedManagementProfilEditRouteImport.update({
    id: '/profil/edit',
    path: '/profil/edit',
    getParentRoute: () => AuthenticatedManagementRouteRoute,
  } as any)
const AuthenticatedManagementVerkehrszeichenIndexRoute =
  AuthenticatedManagementVerkehrszeichenIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedManagementVerkehrszeichenRouteRoute,
  } as any)
const AuthenticatedManagementVerkehrszeichenAdminLevelIdRoute =
  AuthenticatedManagementVerkehrszeichenAdminLevelIdRouteImport.update({
    id: '/$adminLevelId',
    path: '/$adminLevelId',
    getParentRoute: () => AuthenticatedManagementVerkehrszeichenRouteRoute,
  } as any)
const AuthenticatedManagementVorgaengeIndexRoute =
  AuthenticatedManagementVorgaengeIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedManagementVorgaengeRouteRoute,
  } as any)
const AuthenticatedPruefungProcessIdExaminationIdRoute =
  AuthenticatedPruefungProcessIdExaminationIdRouteImport.update({
    id: '/$processId/$examinationId',
    path: '/$processId/$examinationId',
    getParentRoute: () => AuthenticatedPruefungRouteRoute,
  } as any)
const AuthenticatedManagementAdministrationBenutzerinnenIndexRoute =
  AuthenticatedManagementAdministrationBenutzerinnenIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedManagementAdministrationBenutzerinnenRouteRoute,
  } as any)
const AuthenticatedManagementAdministrationBenutzerinnenUserIdRoute =
  AuthenticatedManagementAdministrationBenutzerinnenUserIdRouteImport.update({
    id: '/$userId',
    path: '/$userId',
    getParentRoute: () =>
      AuthenticatedManagementAdministrationBenutzerinnenRouteRoute,
  } as any)
const AuthenticatedManagementAdministrationOrganisationenIndexRoute =
  AuthenticatedManagementAdministrationOrganisationenIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedManagementAdministrationOrganisationenRouteRoute,
  } as any)
const AuthenticatedManagementAdministrationOrganisationenHinzufuegenRoute =
  AuthenticatedManagementAdministrationOrganisationenHinzufuegenRouteImport.update(
    {
      id: '/hinzufuegen',
      path: '/hinzufuegen',
      getParentRoute: () =>
        AuthenticatedManagementAdministrationOrganisationenRouteRoute,
    } as any,
  )
const AuthenticatedManagementAdministrationPruefroutinenIndexRoute =
  AuthenticatedManagementAdministrationPruefroutinenIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedManagementAdministrationPruefroutinenRouteRoute,
  } as any)
const AuthenticatedManagementAdministrationVerwaltungsebenenIndexRoute =
  AuthenticatedManagementAdministrationVerwaltungsebenenIndexRouteImport.update(
    {
      id: '/verwaltungsebenen/',
      path: '/verwaltungsebenen/',
      getParentRoute: () => AuthenticatedManagementAdministrationRouteRoute,
    } as any,
  )
const AuthenticatedManagementMeineOrganisationBenutzerinnenIndexRoute =
  AuthenticatedManagementMeineOrganisationBenutzerinnenIndexRouteImport.update({
    id: '/benutzerinnen/',
    path: '/benutzerinnen/',
    getParentRoute: () => AuthenticatedManagementMeineOrganisationRouteRoute,
  } as any)
const AuthenticatedManagementMeineOrganisationBenutzerinnenUserIdRoute =
  AuthenticatedManagementMeineOrganisationBenutzerinnenUserIdRouteImport.update(
    {
      id: '/benutzerinnen/$userId',
      path: '/benutzerinnen/$userId',
      getParentRoute: () => AuthenticatedManagementMeineOrganisationRouteRoute,
    } as any,
  )
const AuthenticatedManagementMeineOrganisationImporteIndexRoute =
  AuthenticatedManagementMeineOrganisationImporteIndexRouteImport.update({
    id: '/importe/',
    path: '/importe/',
    getParentRoute: () => AuthenticatedManagementMeineOrganisationRouteRoute,
  } as any)
const AuthenticatedManagementMeineOrganisationStakeholderIndexRoute =
  AuthenticatedManagementMeineOrganisationStakeholderIndexRouteImport.update({
    id: '/stakeholder/',
    path: '/stakeholder/',
    getParentRoute: () => AuthenticatedManagementMeineOrganisationRouteRoute,
  } as any)
const AuthenticatedManagementMeineOrganisationStammdatenIndexRoute =
  AuthenticatedManagementMeineOrganisationStammdatenIndexRouteImport.update({
    id: '/stammdaten/',
    path: '/stammdaten/',
    getParentRoute: () => AuthenticatedManagementMeineOrganisationRouteRoute,
  } as any)
const AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdRoute =
  AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdRouteImport.update(
    {
      id: '/$signSupportId',
      path: '/$signSupportId',
      getParentRoute: () =>
        AuthenticatedManagementVerkehrszeichenAdminLevelIdRoute,
    } as any,
  )
const AuthenticatedManagementVerkehrszeichenAdminLevelIdHinzufuegenRoute =
  AuthenticatedManagementVerkehrszeichenAdminLevelIdHinzufuegenRouteImport.update(
    {
      id: '/hinzufuegen',
      path: '/hinzufuegen',
      getParentRoute: () =>
        AuthenticatedManagementVerkehrszeichenAdminLevelIdRoute,
    } as any,
  )
const AuthenticatedManagementVerkehrszeichenRechercheIndexRoute =
  AuthenticatedManagementVerkehrszeichenRechercheIndexRouteImport.update({
    id: '/recherche/',
    path: '/recherche/',
    getParentRoute: () => AuthenticatedManagementVerkehrszeichenRouteRoute,
  } as any)
const AuthenticatedManagementVerkehrszeichenRechercheSignSupportIdRoute =
  AuthenticatedManagementVerkehrszeichenRechercheSignSupportIdRouteImport.update(
    {
      id: '/recherche/$signSupportId',
      path: '/recherche/$signSupportId',
      getParentRoute: () => AuthenticatedManagementVerkehrszeichenRouteRoute,
    } as any,
  )
const AuthenticatedManagementVorgaengeAdminLevelIdIndexRoute =
  AuthenticatedManagementVorgaengeAdminLevelIdIndexRouteImport.update({
    id: '/$adminLevelId/',
    path: '/$adminLevelId/',
    getParentRoute: () => AuthenticatedManagementVorgaengeRouteRoute,
  } as any)
const AuthenticatedManagementVorgaengeRechercheIndexRoute =
  AuthenticatedManagementVorgaengeRechercheIndexRouteImport.update({
    id: '/recherche/',
    path: '/recherche/',
    getParentRoute: () => AuthenticatedManagementVorgaengeRouteRoute,
  } as any)
const AuthenticatedManagementAdministrationOrganisationenOrganizationIdIndexRoute =
  AuthenticatedManagementAdministrationOrganisationenOrganizationIdIndexRouteImport.update(
    {
      id: '/$organizationId/',
      path: '/$organizationId/',
      getParentRoute: () =>
        AuthenticatedManagementAdministrationOrganisationenRouteRoute,
    } as any,
  )
const AuthenticatedManagementAdministrationVerwaltungsebenenAdminLevelIdIndexRoute =
  AuthenticatedManagementAdministrationVerwaltungsebenenAdminLevelIdIndexRouteImport.update(
    {
      id: '/verwaltungsebenen/$adminLevelId/',
      path: '/verwaltungsebenen/$adminLevelId/',
      getParentRoute: () => AuthenticatedManagementAdministrationRouteRoute,
    } as any,
  )
const AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdBearbeitenRoute =
  AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdBearbeitenRouteImport.update(
    {
      id: '/bearbeiten',
      path: '/bearbeiten',
      getParentRoute: () =>
        AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdRoute,
    } as any,
  )
const AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdHinzufuegenRoute =
  AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdHinzufuegenRouteImport.update(
    {
      id: '/hinzufuegen',
      path: '/hinzufuegen',
      getParentRoute: () =>
        AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdRoute,
    } as any,
  )
const AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdRoute =
  AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdRouteImport.update(
    {
      id: '/$signSupportId_/$signGroupId',
      path: '/$signSupportId/$signGroupId',
      getParentRoute: () =>
        AuthenticatedManagementVerkehrszeichenAdminLevelIdRoute,
    } as any,
  )
const AuthenticatedManagementVerkehrszeichenRechercheSignSupportIdSignGroupIdRoute =
  AuthenticatedManagementVerkehrszeichenRechercheSignSupportIdSignGroupIdRouteImport.update(
    {
      id: '/recherche/$signSupportId_/$signGroupId',
      path: '/recherche/$signSupportId/$signGroupId',
      getParentRoute: () => AuthenticatedManagementVerkehrszeichenRouteRoute,
    } as any,
  )
const AuthenticatedManagementVorgaengeAdminLevelIdProcessIdIndexRoute =
  AuthenticatedManagementVorgaengeAdminLevelIdProcessIdIndexRouteImport.update({
    id: '/$adminLevelId/$processId/',
    path: '/$adminLevelId/$processId/',
    getParentRoute: () => AuthenticatedManagementVorgaengeRouteRoute,
  } as any)
const AuthenticatedManagementVorgaengeAdminLevelIdProcessIdExaminationIdRoute =
  AuthenticatedManagementVorgaengeAdminLevelIdProcessIdExaminationIdRouteImport.update(
    {
      id: '/$adminLevelId/$processId/$examinationId',
      path: '/$adminLevelId/$processId/$examinationId',
      getParentRoute: () => AuthenticatedManagementVorgaengeRouteRoute,
    } as any,
  )
const AuthenticatedManagementVorgaengeAdminLevelIdProcessIdEditRoute =
  AuthenticatedManagementVorgaengeAdminLevelIdProcessIdEditRouteImport.update({
    id: '/$adminLevelId/$processId/edit',
    path: '/$adminLevelId/$processId/edit',
    getParentRoute: () => AuthenticatedManagementVorgaengeRouteRoute,
  } as any)
const AuthenticatedManagementVorgaengeAdminLevelIdKarteIndexRoute =
  AuthenticatedManagementVorgaengeAdminLevelIdKarteIndexRouteImport.update({
    id: '/$adminLevelId/karte/',
    path: '/$adminLevelId/karte/',
    getParentRoute: () => AuthenticatedManagementVorgaengeRouteRoute,
  } as any)
const AuthenticatedManagementAdministrationBenutzerinnenUserIdOrganisationHinzufuegenRoute =
  AuthenticatedManagementAdministrationBenutzerinnenUserIdOrganisationHinzufuegenRouteImport.update(
    {
      id: '/$userId_/organisation/hinzufuegen',
      path: '/$userId/organisation/hinzufuegen',
      getParentRoute: () =>
        AuthenticatedManagementAdministrationBenutzerinnenRouteRoute,
    } as any,
  )
const AuthenticatedManagementAdministrationOrganisationenOrganizationIdBenutzerinnenUserIdRoute =
  AuthenticatedManagementAdministrationOrganisationenOrganizationIdBenutzerinnenUserIdRouteImport.update(
    {
      id: '/$organizationId/benutzerinnen/$userId',
      path: '/$organizationId/benutzerinnen/$userId',
      getParentRoute: () =>
        AuthenticatedManagementAdministrationOrganisationenRouteRoute,
    } as any,
  )
const AuthenticatedManagementAdministrationOrganisationenOrganizationIdVerwaltungsebenenAdminLevelIdRoute =
  AuthenticatedManagementAdministrationOrganisationenOrganizationIdVerwaltungsebenenAdminLevelIdRouteImport.update(
    {
      id: '/$organizationId/verwaltungsebenen/$adminLevelId',
      path: '/$organizationId/verwaltungsebenen/$adminLevelId',
      getParentRoute: () =>
        AuthenticatedManagementAdministrationOrganisationenRouteRoute,
    } as any,
  )
const AuthenticatedManagementAdministrationVerwaltungsebenenAdminLevelIdOrganisationenHinzufuegenRoute =
  AuthenticatedManagementAdministrationVerwaltungsebenenAdminLevelIdOrganisationenHinzufuegenRouteImport.update(
    {
      id: '/verwaltungsebenen/$adminLevelId/organisationen/hinzufuegen',
      path: '/verwaltungsebenen/$adminLevelId/organisationen/hinzufuegen',
      getParentRoute: () => AuthenticatedManagementAdministrationRouteRoute,
    } as any,
  )
const AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdBearbeitenRoute =
  AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdBearbeitenRouteImport.update(
    {
      id: '/bearbeiten',
      path: '/bearbeiten',
      getParentRoute: () =>
        AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdRoute,
    } as any,
  )
const AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdDuplizierenRoute =
  AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdDuplizierenRouteImport.update(
    {
      id: '/duplizieren',
      path: '/duplizieren',
      getParentRoute: () =>
        AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdRoute,
    } as any,
  )
const AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdHinzufuegenRoute =
  AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdHinzufuegenRouteImport.update(
    {
      id: '/hinzufuegen',
      path: '/hinzufuegen',
      getParentRoute: () =>
        AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdRoute,
    } as any,
  )
const AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdSignIdRoute =
  AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdSignIdRouteImport.update(
    {
      id: '/$signSupportId_/$signGroupId_/$signId',
      path: '/$signSupportId/$signGroupId/$signId',
      getParentRoute: () =>
        AuthenticatedManagementVerkehrszeichenAdminLevelIdRoute,
    } as any,
  )
const AuthenticatedManagementVerkehrszeichenRechercheSignSupportIdSignGroupIdSignIdRoute =
  AuthenticatedManagementVerkehrszeichenRechercheSignSupportIdSignGroupIdSignIdRouteImport.update(
    {
      id: '/recherche/$signSupportId_/$signGroupId_/$signId',
      path: '/recherche/$signSupportId/$signGroupId/$signId',
      getParentRoute: () => AuthenticatedManagementVerkehrszeichenRouteRoute,
    } as any,
  )
const AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdSignIdBearbeitenRoute =
  AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdSignIdBearbeitenRouteImport.update(
    {
      id: '/bearbeiten',
      path: '/bearbeiten',
      getParentRoute: () =>
        AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdSignIdRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/anordnung': typeof AuthenticatedAnordnungRouteRouteWithChildren
  '/hilfe': typeof AuthenticatedHilfeRouteRouteWithChildren
  '/pruefung': typeof AuthenticatedPruefungRouteRouteWithChildren
  '/barrierefreiheit': typeof AuthenticatedBarrierefreiheitRoute
  '/datenschutz': typeof AuthenticatedDatenschutzRoute
  '/impressum': typeof AuthenticatedImpressumRoute
  '/kontakt': typeof AuthenticatedKontaktRoute
  '/nutzungsbedingungen': typeof AuthenticatedNutzungsbedingungenRoute
  '/registrierung': typeof AuthenticatedRegistrierungRoute
  '/administration': typeof AuthenticatedManagementAdministrationRouteRouteWithChildren
  '/meine-organisation': typeof AuthenticatedManagementMeineOrganisationRouteRouteWithChildren
  '/verkehrszeichen': typeof AuthenticatedManagementVerkehrszeichenRouteRouteWithChildren
  '/vorgaenge': typeof AuthenticatedManagementVorgaengeRouteRouteWithChildren
  '/anordnung/$processId': typeof AuthenticatedAnordnungProcessIdRoute
  '/anordnung/success': typeof AuthenticatedAnordnungSuccessRoute
  '/hilfe/benutzerverwaltung': typeof AuthenticatedHilfeBenutzerverwaltungRoute
  '/hilfe/datenschnittstellen': typeof AuthenticatedHilfeDatenschnittstellenRoute
  '/hilfe/funktionsuebersicht': typeof AuthenticatedHilfeFunktionsuebersichtRoute
  '/hilfe/klickanleitungen': typeof AuthenticatedHilfeKlickanleitungenRoute
  '/hilfe/organisationsverwaltung': typeof AuthenticatedHilfeOrganisationsverwaltungRoute
  '/hilfe/release-notes': typeof AuthenticatedHilfeReleaseNotesRoute
  '/hilfe/verkehrszeichen-datenmodell': typeof AuthenticatedHilfeVerkehrszeichenDatenmodellRoute
  '/hilfe/verkehrszeichen-edit': typeof AuthenticatedHilfeVerkehrszeichenEditRoute
  '/hilfe/vorgaenge': typeof AuthenticatedHilfeVorgaengeRoute
  '/hilfe/': typeof AuthenticatedHilfeIndexRoute
  '/administration/benutzerinnen': typeof AuthenticatedManagementAdministrationBenutzerinnenRouteRouteWithChildren
  '/administration/organisationen': typeof AuthenticatedManagementAdministrationOrganisationenRouteRouteWithChildren
  '/administration/pruefroutinen': typeof AuthenticatedManagementAdministrationPruefroutinenRouteRouteWithChildren
  '/profil/edit': typeof AuthenticatedManagementProfilEditRoute
  '/verkehrszeichen/$adminLevelId': typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdRouteWithChildren
  '/pruefung/$processId/$examinationId': typeof AuthenticatedPruefungProcessIdExaminationIdRoute
  '/profil/': typeof AuthenticatedManagementProfilIndexRoute
  '/verkehrszeichen/': typeof AuthenticatedManagementVerkehrszeichenIndexRoute
  '/vorgaenge/': typeof AuthenticatedManagementVorgaengeIndexRoute
  '/administration/benutzerinnen/$userId': typeof AuthenticatedManagementAdministrationBenutzerinnenUserIdRoute
  '/administration/organisationen/hinzufuegen': typeof AuthenticatedManagementAdministrationOrganisationenHinzufuegenRoute
  '/meine-organisation/benutzerinnen/$userId': typeof AuthenticatedManagementMeineOrganisationBenutzerinnenUserIdRoute
  '/verkehrszeichen/$adminLevelId/$signSupportId': typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdRouteWithChildren
  '/verkehrszeichen/$adminLevelId/hinzufuegen': typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdHinzufuegenRoute
  '/verkehrszeichen/recherche/$signSupportId': typeof AuthenticatedManagementVerkehrszeichenRechercheSignSupportIdRoute
  '/administration/benutzerinnen/': typeof AuthenticatedManagementAdministrationBenutzerinnenIndexRoute
  '/administration/organisationen/': typeof AuthenticatedManagementAdministrationOrganisationenIndexRoute
  '/administration/pruefroutinen/': typeof AuthenticatedManagementAdministrationPruefroutinenIndexRoute
  '/administration/verwaltungsebenen/': typeof AuthenticatedManagementAdministrationVerwaltungsebenenIndexRoute
  '/meine-organisation/benutzerinnen/': typeof AuthenticatedManagementMeineOrganisationBenutzerinnenIndexRoute
  '/meine-organisation/importe/': typeof AuthenticatedManagementMeineOrganisationImporteIndexRoute
  '/meine-organisation/stakeholder/': typeof AuthenticatedManagementMeineOrganisationStakeholderIndexRoute
  '/meine-organisation/stammdaten/': typeof AuthenticatedManagementMeineOrganisationStammdatenIndexRoute
  '/verkehrszeichen/recherche/': typeof AuthenticatedManagementVerkehrszeichenRechercheIndexRoute
  '/vorgaenge/$adminLevelId/': typeof AuthenticatedManagementVorgaengeAdminLevelIdIndexRoute
  '/vorgaenge/recherche/': typeof AuthenticatedManagementVorgaengeRechercheIndexRoute
  '/verkehrszeichen/$adminLevelId/$signSupportId/bearbeiten': typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdBearbeitenRoute
  '/verkehrszeichen/$adminLevelId/$signSupportId/hinzufuegen': typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdHinzufuegenRoute
  '/verkehrszeichen/$adminLevelId/$signSupportId/$signGroupId': typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdRouteWithChildren
  '/verkehrszeichen/recherche/$signSupportId/$signGroupId': typeof AuthenticatedManagementVerkehrszeichenRechercheSignSupportIdSignGroupIdRoute
  '/vorgaenge/$adminLevelId/$processId/$examinationId': typeof AuthenticatedManagementVorgaengeAdminLevelIdProcessIdExaminationIdRoute
  '/vorgaenge/$adminLevelId/$processId/edit': typeof AuthenticatedManagementVorgaengeAdminLevelIdProcessIdEditRoute
  '/administration/organisationen/$organizationId/': typeof AuthenticatedManagementAdministrationOrganisationenOrganizationIdIndexRoute
  '/administration/verwaltungsebenen/$adminLevelId/': typeof AuthenticatedManagementAdministrationVerwaltungsebenenAdminLevelIdIndexRoute
  '/vorgaenge/$adminLevelId/$processId/': typeof AuthenticatedManagementVorgaengeAdminLevelIdProcessIdIndexRoute
  '/vorgaenge/$adminLevelId/karte/': typeof AuthenticatedManagementVorgaengeAdminLevelIdKarteIndexRoute
  '/administration/benutzerinnen/$userId/organisation/hinzufuegen': typeof AuthenticatedManagementAdministrationBenutzerinnenUserIdOrganisationHinzufuegenRoute
  '/administration/organisationen/$organizationId/benutzerinnen/$userId': typeof AuthenticatedManagementAdministrationOrganisationenOrganizationIdBenutzerinnenUserIdRoute
  '/administration/organisationen/$organizationId/verwaltungsebenen/$adminLevelId': typeof AuthenticatedManagementAdministrationOrganisationenOrganizationIdVerwaltungsebenenAdminLevelIdRoute
  '/administration/verwaltungsebenen/$adminLevelId/organisationen/hinzufuegen': typeof AuthenticatedManagementAdministrationVerwaltungsebenenAdminLevelIdOrganisationenHinzufuegenRoute
  '/verkehrszeichen/$adminLevelId/$signSupportId/$signGroupId/bearbeiten': typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdBearbeitenRoute
  '/verkehrszeichen/$adminLevelId/$signSupportId/$signGroupId/duplizieren': typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdDuplizierenRoute
  '/verkehrszeichen/$adminLevelId/$signSupportId/$signGroupId/hinzufuegen': typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdHinzufuegenRoute
  '/verkehrszeichen/$adminLevelId/$signSupportId/$signGroupId/$signId': typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdSignIdRouteWithChildren
  '/verkehrszeichen/recherche/$signSupportId/$signGroupId/$signId': typeof AuthenticatedManagementVerkehrszeichenRechercheSignSupportIdSignGroupIdSignIdRoute
  '/verkehrszeichen/$adminLevelId/$signSupportId/$signGroupId/$signId/bearbeiten': typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdSignIdBearbeitenRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/anordnung': typeof AuthenticatedAnordnungRouteRouteWithChildren
  '/pruefung': typeof AuthenticatedPruefungRouteRouteWithChildren
  '/barrierefreiheit': typeof AuthenticatedBarrierefreiheitRoute
  '/datenschutz': typeof AuthenticatedDatenschutzRoute
  '/impressum': typeof AuthenticatedImpressumRoute
  '/kontakt': typeof AuthenticatedKontaktRoute
  '/nutzungsbedingungen': typeof AuthenticatedNutzungsbedingungenRoute
  '/registrierung': typeof AuthenticatedRegistrierungRoute
  '/administration': typeof AuthenticatedManagementAdministrationRouteRouteWithChildren
  '/meine-organisation': typeof AuthenticatedManagementMeineOrganisationRouteRouteWithChildren
  '/anordnung/$processId': typeof AuthenticatedAnordnungProcessIdRoute
  '/anordnung/success': typeof AuthenticatedAnordnungSuccessRoute
  '/hilfe/benutzerverwaltung': typeof AuthenticatedHilfeBenutzerverwaltungRoute
  '/hilfe/datenschnittstellen': typeof AuthenticatedHilfeDatenschnittstellenRoute
  '/hilfe/funktionsuebersicht': typeof AuthenticatedHilfeFunktionsuebersichtRoute
  '/hilfe/klickanleitungen': typeof AuthenticatedHilfeKlickanleitungenRoute
  '/hilfe/organisationsverwaltung': typeof AuthenticatedHilfeOrganisationsverwaltungRoute
  '/hilfe/release-notes': typeof AuthenticatedHilfeReleaseNotesRoute
  '/hilfe/verkehrszeichen-datenmodell': typeof AuthenticatedHilfeVerkehrszeichenDatenmodellRoute
  '/hilfe/verkehrszeichen-edit': typeof AuthenticatedHilfeVerkehrszeichenEditRoute
  '/hilfe/vorgaenge': typeof AuthenticatedHilfeVorgaengeRoute
  '/hilfe': typeof AuthenticatedHilfeIndexRoute
  '/profil/edit': typeof AuthenticatedManagementProfilEditRoute
  '/verkehrszeichen/$adminLevelId': typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdRouteWithChildren
  '/pruefung/$processId/$examinationId': typeof AuthenticatedPruefungProcessIdExaminationIdRoute
  '/profil': typeof AuthenticatedManagementProfilIndexRoute
  '/verkehrszeichen': typeof AuthenticatedManagementVerkehrszeichenIndexRoute
  '/vorgaenge': typeof AuthenticatedManagementVorgaengeIndexRoute
  '/administration/benutzerinnen/$userId': typeof AuthenticatedManagementAdministrationBenutzerinnenUserIdRoute
  '/administration/organisationen/hinzufuegen': typeof AuthenticatedManagementAdministrationOrganisationenHinzufuegenRoute
  '/meine-organisation/benutzerinnen/$userId': typeof AuthenticatedManagementMeineOrganisationBenutzerinnenUserIdRoute
  '/verkehrszeichen/$adminLevelId/$signSupportId': typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdRouteWithChildren
  '/verkehrszeichen/$adminLevelId/hinzufuegen': typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdHinzufuegenRoute
  '/verkehrszeichen/recherche/$signSupportId': typeof AuthenticatedManagementVerkehrszeichenRechercheSignSupportIdRoute
  '/administration/benutzerinnen': typeof AuthenticatedManagementAdministrationBenutzerinnenIndexRoute
  '/administration/organisationen': typeof AuthenticatedManagementAdministrationOrganisationenIndexRoute
  '/administration/pruefroutinen': typeof AuthenticatedManagementAdministrationPruefroutinenIndexRoute
  '/administration/verwaltungsebenen': typeof AuthenticatedManagementAdministrationVerwaltungsebenenIndexRoute
  '/meine-organisation/benutzerinnen': typeof AuthenticatedManagementMeineOrganisationBenutzerinnenIndexRoute
  '/meine-organisation/importe': typeof AuthenticatedManagementMeineOrganisationImporteIndexRoute
  '/meine-organisation/stakeholder': typeof AuthenticatedManagementMeineOrganisationStakeholderIndexRoute
  '/meine-organisation/stammdaten': typeof AuthenticatedManagementMeineOrganisationStammdatenIndexRoute
  '/verkehrszeichen/recherche': typeof AuthenticatedManagementVerkehrszeichenRechercheIndexRoute
  '/vorgaenge/$adminLevelId': typeof AuthenticatedManagementVorgaengeAdminLevelIdIndexRoute
  '/vorgaenge/recherche': typeof AuthenticatedManagementVorgaengeRechercheIndexRoute
  '/verkehrszeichen/$adminLevelId/$signSupportId/bearbeiten': typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdBearbeitenRoute
  '/verkehrszeichen/$adminLevelId/$signSupportId/hinzufuegen': typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdHinzufuegenRoute
  '/verkehrszeichen/$adminLevelId/$signSupportId/$signGroupId': typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdRouteWithChildren
  '/verkehrszeichen/recherche/$signSupportId/$signGroupId': typeof AuthenticatedManagementVerkehrszeichenRechercheSignSupportIdSignGroupIdRoute
  '/vorgaenge/$adminLevelId/$processId/$examinationId': typeof AuthenticatedManagementVorgaengeAdminLevelIdProcessIdExaminationIdRoute
  '/vorgaenge/$adminLevelId/$processId/edit': typeof AuthenticatedManagementVorgaengeAdminLevelIdProcessIdEditRoute
  '/administration/organisationen/$organizationId': typeof AuthenticatedManagementAdministrationOrganisationenOrganizationIdIndexRoute
  '/administration/verwaltungsebenen/$adminLevelId': typeof AuthenticatedManagementAdministrationVerwaltungsebenenAdminLevelIdIndexRoute
  '/vorgaenge/$adminLevelId/$processId': typeof AuthenticatedManagementVorgaengeAdminLevelIdProcessIdIndexRoute
  '/vorgaenge/$adminLevelId/karte': typeof AuthenticatedManagementVorgaengeAdminLevelIdKarteIndexRoute
  '/administration/benutzerinnen/$userId/organisation/hinzufuegen': typeof AuthenticatedManagementAdministrationBenutzerinnenUserIdOrganisationHinzufuegenRoute
  '/administration/organisationen/$organizationId/benutzerinnen/$userId': typeof AuthenticatedManagementAdministrationOrganisationenOrganizationIdBenutzerinnenUserIdRoute
  '/administration/organisationen/$organizationId/verwaltungsebenen/$adminLevelId': typeof AuthenticatedManagementAdministrationOrganisationenOrganizationIdVerwaltungsebenenAdminLevelIdRoute
  '/administration/verwaltungsebenen/$adminLevelId/organisationen/hinzufuegen': typeof AuthenticatedManagementAdministrationVerwaltungsebenenAdminLevelIdOrganisationenHinzufuegenRoute
  '/verkehrszeichen/$adminLevelId/$signSupportId/$signGroupId/bearbeiten': typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdBearbeitenRoute
  '/verkehrszeichen/$adminLevelId/$signSupportId/$signGroupId/duplizieren': typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdDuplizierenRoute
  '/verkehrszeichen/$adminLevelId/$signSupportId/$signGroupId/hinzufuegen': typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdHinzufuegenRoute
  '/verkehrszeichen/$adminLevelId/$signSupportId/$signGroupId/$signId': typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdSignIdRouteWithChildren
  '/verkehrszeichen/recherche/$signSupportId/$signGroupId/$signId': typeof AuthenticatedManagementVerkehrszeichenRechercheSignSupportIdSignGroupIdSignIdRoute
  '/verkehrszeichen/$adminLevelId/$signSupportId/$signGroupId/$signId/bearbeiten': typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdSignIdBearbeitenRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/_authenticated/_management': typeof AuthenticatedManagementRouteRouteWithChildren
  '/_authenticated/anordnung': typeof AuthenticatedAnordnungRouteRouteWithChildren
  '/_authenticated/hilfe': typeof AuthenticatedHilfeRouteRouteWithChildren
  '/_authenticated/pruefung': typeof AuthenticatedPruefungRouteRouteWithChildren
  '/_authenticated/barrierefreiheit': typeof AuthenticatedBarrierefreiheitRoute
  '/_authenticated/datenschutz': typeof AuthenticatedDatenschutzRoute
  '/_authenticated/impressum': typeof AuthenticatedImpressumRoute
  '/_authenticated/kontakt': typeof AuthenticatedKontaktRoute
  '/_authenticated/nutzungsbedingungen': typeof AuthenticatedNutzungsbedingungenRoute
  '/_authenticated/registrierung': typeof AuthenticatedRegistrierungRoute
  '/_authenticated/_management/administration': typeof AuthenticatedManagementAdministrationRouteRouteWithChildren
  '/_authenticated/_management/meine-organisation': typeof AuthenticatedManagementMeineOrganisationRouteRouteWithChildren
  '/_authenticated/_management/verkehrszeichen': typeof AuthenticatedManagementVerkehrszeichenRouteRouteWithChildren
  '/_authenticated/_management/vorgaenge': typeof AuthenticatedManagementVorgaengeRouteRouteWithChildren
  '/_authenticated/anordnung/$processId': typeof AuthenticatedAnordnungProcessIdRoute
  '/_authenticated/anordnung/success': typeof AuthenticatedAnordnungSuccessRoute
  '/_authenticated/hilfe/benutzerverwaltung': typeof AuthenticatedHilfeBenutzerverwaltungRoute
  '/_authenticated/hilfe/datenschnittstellen': typeof AuthenticatedHilfeDatenschnittstellenRoute
  '/_authenticated/hilfe/funktionsuebersicht': typeof AuthenticatedHilfeFunktionsuebersichtRoute
  '/_authenticated/hilfe/klickanleitungen': typeof AuthenticatedHilfeKlickanleitungenRoute
  '/_authenticated/hilfe/organisationsverwaltung': typeof AuthenticatedHilfeOrganisationsverwaltungRoute
  '/_authenticated/hilfe/release-notes': typeof AuthenticatedHilfeReleaseNotesRoute
  '/_authenticated/hilfe/verkehrszeichen-datenmodell': typeof AuthenticatedHilfeVerkehrszeichenDatenmodellRoute
  '/_authenticated/hilfe/verkehrszeichen-edit': typeof AuthenticatedHilfeVerkehrszeichenEditRoute
  '/_authenticated/hilfe/vorgaenge': typeof AuthenticatedHilfeVorgaengeRoute
  '/_authenticated/hilfe/': typeof AuthenticatedHilfeIndexRoute
  '/_authenticated/_management/administration/benutzerinnen': typeof AuthenticatedManagementAdministrationBenutzerinnenRouteRouteWithChildren
  '/_authenticated/_management/administration/organisationen': typeof AuthenticatedManagementAdministrationOrganisationenRouteRouteWithChildren
  '/_authenticated/_management/administration/pruefroutinen': typeof AuthenticatedManagementAdministrationPruefroutinenRouteRouteWithChildren
  '/_authenticated/_management/profil/edit': typeof AuthenticatedManagementProfilEditRoute
  '/_authenticated/_management/verkehrszeichen/$adminLevelId': typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdRouteWithChildren
  '/_authenticated/pruefung/$processId/$examinationId': typeof AuthenticatedPruefungProcessIdExaminationIdRoute
  '/_authenticated/_management/profil/': typeof AuthenticatedManagementProfilIndexRoute
  '/_authenticated/_management/verkehrszeichen/': typeof AuthenticatedManagementVerkehrszeichenIndexRoute
  '/_authenticated/_management/vorgaenge/': typeof AuthenticatedManagementVorgaengeIndexRoute
  '/_authenticated/_management/administration/benutzerinnen/$userId': typeof AuthenticatedManagementAdministrationBenutzerinnenUserIdRoute
  '/_authenticated/_management/administration/organisationen/hinzufuegen': typeof AuthenticatedManagementAdministrationOrganisationenHinzufuegenRoute
  '/_authenticated/_management/meine-organisation/benutzerinnen/$userId': typeof AuthenticatedManagementMeineOrganisationBenutzerinnenUserIdRoute
  '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId': typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdRouteWithChildren
  '/_authenticated/_management/verkehrszeichen/$adminLevelId/hinzufuegen': typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdHinzufuegenRoute
  '/_authenticated/_management/verkehrszeichen/recherche/$signSupportId': typeof AuthenticatedManagementVerkehrszeichenRechercheSignSupportIdRoute
  '/_authenticated/_management/administration/benutzerinnen/': typeof AuthenticatedManagementAdministrationBenutzerinnenIndexRoute
  '/_authenticated/_management/administration/organisationen/': typeof AuthenticatedManagementAdministrationOrganisationenIndexRoute
  '/_authenticated/_management/administration/pruefroutinen/': typeof AuthenticatedManagementAdministrationPruefroutinenIndexRoute
  '/_authenticated/_management/administration/verwaltungsebenen/': typeof AuthenticatedManagementAdministrationVerwaltungsebenenIndexRoute
  '/_authenticated/_management/meine-organisation/benutzerinnen/': typeof AuthenticatedManagementMeineOrganisationBenutzerinnenIndexRoute
  '/_authenticated/_management/meine-organisation/importe/': typeof AuthenticatedManagementMeineOrganisationImporteIndexRoute
  '/_authenticated/_management/meine-organisation/stakeholder/': typeof AuthenticatedManagementMeineOrganisationStakeholderIndexRoute
  '/_authenticated/_management/meine-organisation/stammdaten/': typeof AuthenticatedManagementMeineOrganisationStammdatenIndexRoute
  '/_authenticated/_management/verkehrszeichen/recherche/': typeof AuthenticatedManagementVerkehrszeichenRechercheIndexRoute
  '/_authenticated/_management/vorgaenge/$adminLevelId/': typeof AuthenticatedManagementVorgaengeAdminLevelIdIndexRoute
  '/_authenticated/_management/vorgaenge/recherche/': typeof AuthenticatedManagementVorgaengeRechercheIndexRoute
  '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId/bearbeiten': typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdBearbeitenRoute
  '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId/hinzufuegen': typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdHinzufuegenRoute
  '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId_/$signGroupId': typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdRouteWithChildren
  '/_authenticated/_management/verkehrszeichen/recherche/$signSupportId_/$signGroupId': typeof AuthenticatedManagementVerkehrszeichenRechercheSignSupportIdSignGroupIdRoute
  '/_authenticated/_management/vorgaenge/$adminLevelId/$processId/$examinationId': typeof AuthenticatedManagementVorgaengeAdminLevelIdProcessIdExaminationIdRoute
  '/_authenticated/_management/vorgaenge/$adminLevelId/$processId/edit': typeof AuthenticatedManagementVorgaengeAdminLevelIdProcessIdEditRoute
  '/_authenticated/_management/administration/organisationen/$organizationId/': typeof AuthenticatedManagementAdministrationOrganisationenOrganizationIdIndexRoute
  '/_authenticated/_management/administration/verwaltungsebenen/$adminLevelId/': typeof AuthenticatedManagementAdministrationVerwaltungsebenenAdminLevelIdIndexRoute
  '/_authenticated/_management/vorgaenge/$adminLevelId/$processId/': typeof AuthenticatedManagementVorgaengeAdminLevelIdProcessIdIndexRoute
  '/_authenticated/_management/vorgaenge/$adminLevelId/karte/': typeof AuthenticatedManagementVorgaengeAdminLevelIdKarteIndexRoute
  '/_authenticated/_management/administration/benutzerinnen/$userId_/organisation/hinzufuegen': typeof AuthenticatedManagementAdministrationBenutzerinnenUserIdOrganisationHinzufuegenRoute
  '/_authenticated/_management/administration/organisationen/$organizationId/benutzerinnen/$userId': typeof AuthenticatedManagementAdministrationOrganisationenOrganizationIdBenutzerinnenUserIdRoute
  '/_authenticated/_management/administration/organisationen/$organizationId/verwaltungsebenen/$adminLevelId': typeof AuthenticatedManagementAdministrationOrganisationenOrganizationIdVerwaltungsebenenAdminLevelIdRoute
  '/_authenticated/_management/administration/verwaltungsebenen/$adminLevelId/organisationen/hinzufuegen': typeof AuthenticatedManagementAdministrationVerwaltungsebenenAdminLevelIdOrganisationenHinzufuegenRoute
  '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId_/$signGroupId/bearbeiten': typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdBearbeitenRoute
  '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId_/$signGroupId/duplizieren': typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdDuplizierenRoute
  '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId_/$signGroupId/hinzufuegen': typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdHinzufuegenRoute
  '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId_/$signGroupId_/$signId': typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdSignIdRouteWithChildren
  '/_authenticated/_management/verkehrszeichen/recherche/$signSupportId_/$signGroupId_/$signId': typeof AuthenticatedManagementVerkehrszeichenRechercheSignSupportIdSignGroupIdSignIdRoute
  '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId_/$signGroupId_/$signId/bearbeiten': typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdSignIdBearbeitenRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/anordnung'
    | '/hilfe'
    | '/pruefung'
    | '/barrierefreiheit'
    | '/datenschutz'
    | '/impressum'
    | '/kontakt'
    | '/nutzungsbedingungen'
    | '/registrierung'
    | '/administration'
    | '/meine-organisation'
    | '/verkehrszeichen'
    | '/vorgaenge'
    | '/anordnung/$processId'
    | '/anordnung/success'
    | '/hilfe/benutzerverwaltung'
    | '/hilfe/datenschnittstellen'
    | '/hilfe/funktionsuebersicht'
    | '/hilfe/klickanleitungen'
    | '/hilfe/organisationsverwaltung'
    | '/hilfe/release-notes'
    | '/hilfe/verkehrszeichen-datenmodell'
    | '/hilfe/verkehrszeichen-edit'
    | '/hilfe/vorgaenge'
    | '/hilfe/'
    | '/administration/benutzerinnen'
    | '/administration/organisationen'
    | '/administration/pruefroutinen'
    | '/profil/edit'
    | '/verkehrszeichen/$adminLevelId'
    | '/pruefung/$processId/$examinationId'
    | '/profil/'
    | '/verkehrszeichen/'
    | '/vorgaenge/'
    | '/administration/benutzerinnen/$userId'
    | '/administration/organisationen/hinzufuegen'
    | '/meine-organisation/benutzerinnen/$userId'
    | '/verkehrszeichen/$adminLevelId/$signSupportId'
    | '/verkehrszeichen/$adminLevelId/hinzufuegen'
    | '/verkehrszeichen/recherche/$signSupportId'
    | '/administration/benutzerinnen/'
    | '/administration/organisationen/'
    | '/administration/pruefroutinen/'
    | '/administration/verwaltungsebenen/'
    | '/meine-organisation/benutzerinnen/'
    | '/meine-organisation/importe/'
    | '/meine-organisation/stakeholder/'
    | '/meine-organisation/stammdaten/'
    | '/verkehrszeichen/recherche/'
    | '/vorgaenge/$adminLevelId/'
    | '/vorgaenge/recherche/'
    | '/verkehrszeichen/$adminLevelId/$signSupportId/bearbeiten'
    | '/verkehrszeichen/$adminLevelId/$signSupportId/hinzufuegen'
    | '/verkehrszeichen/$adminLevelId/$signSupportId/$signGroupId'
    | '/verkehrszeichen/recherche/$signSupportId/$signGroupId'
    | '/vorgaenge/$adminLevelId/$processId/$examinationId'
    | '/vorgaenge/$adminLevelId/$processId/edit'
    | '/administration/organisationen/$organizationId/'
    | '/administration/verwaltungsebenen/$adminLevelId/'
    | '/vorgaenge/$adminLevelId/$processId/'
    | '/vorgaenge/$adminLevelId/karte/'
    | '/administration/benutzerinnen/$userId/organisation/hinzufuegen'
    | '/administration/organisationen/$organizationId/benutzerinnen/$userId'
    | '/administration/organisationen/$organizationId/verwaltungsebenen/$adminLevelId'
    | '/administration/verwaltungsebenen/$adminLevelId/organisationen/hinzufuegen'
    | '/verkehrszeichen/$adminLevelId/$signSupportId/$signGroupId/bearbeiten'
    | '/verkehrszeichen/$adminLevelId/$signSupportId/$signGroupId/duplizieren'
    | '/verkehrszeichen/$adminLevelId/$signSupportId/$signGroupId/hinzufuegen'
    | '/verkehrszeichen/$adminLevelId/$signSupportId/$signGroupId/$signId'
    | '/verkehrszeichen/recherche/$signSupportId/$signGroupId/$signId'
    | '/verkehrszeichen/$adminLevelId/$signSupportId/$signGroupId/$signId/bearbeiten'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/anordnung'
    | '/pruefung'
    | '/barrierefreiheit'
    | '/datenschutz'
    | '/impressum'
    | '/kontakt'
    | '/nutzungsbedingungen'
    | '/registrierung'
    | '/administration'
    | '/meine-organisation'
    | '/anordnung/$processId'
    | '/anordnung/success'
    | '/hilfe/benutzerverwaltung'
    | '/hilfe/datenschnittstellen'
    | '/hilfe/funktionsuebersicht'
    | '/hilfe/klickanleitungen'
    | '/hilfe/organisationsverwaltung'
    | '/hilfe/release-notes'
    | '/hilfe/verkehrszeichen-datenmodell'
    | '/hilfe/verkehrszeichen-edit'
    | '/hilfe/vorgaenge'
    | '/hilfe'
    | '/profil/edit'
    | '/verkehrszeichen/$adminLevelId'
    | '/pruefung/$processId/$examinationId'
    | '/profil'
    | '/verkehrszeichen'
    | '/vorgaenge'
    | '/administration/benutzerinnen/$userId'
    | '/administration/organisationen/hinzufuegen'
    | '/meine-organisation/benutzerinnen/$userId'
    | '/verkehrszeichen/$adminLevelId/$signSupportId'
    | '/verkehrszeichen/$adminLevelId/hinzufuegen'
    | '/verkehrszeichen/recherche/$signSupportId'
    | '/administration/benutzerinnen'
    | '/administration/organisationen'
    | '/administration/pruefroutinen'
    | '/administration/verwaltungsebenen'
    | '/meine-organisation/benutzerinnen'
    | '/meine-organisation/importe'
    | '/meine-organisation/stakeholder'
    | '/meine-organisation/stammdaten'
    | '/verkehrszeichen/recherche'
    | '/vorgaenge/$adminLevelId'
    | '/vorgaenge/recherche'
    | '/verkehrszeichen/$adminLevelId/$signSupportId/bearbeiten'
    | '/verkehrszeichen/$adminLevelId/$signSupportId/hinzufuegen'
    | '/verkehrszeichen/$adminLevelId/$signSupportId/$signGroupId'
    | '/verkehrszeichen/recherche/$signSupportId/$signGroupId'
    | '/vorgaenge/$adminLevelId/$processId/$examinationId'
    | '/vorgaenge/$adminLevelId/$processId/edit'
    | '/administration/organisationen/$organizationId'
    | '/administration/verwaltungsebenen/$adminLevelId'
    | '/vorgaenge/$adminLevelId/$processId'
    | '/vorgaenge/$adminLevelId/karte'
    | '/administration/benutzerinnen/$userId/organisation/hinzufuegen'
    | '/administration/organisationen/$organizationId/benutzerinnen/$userId'
    | '/administration/organisationen/$organizationId/verwaltungsebenen/$adminLevelId'
    | '/administration/verwaltungsebenen/$adminLevelId/organisationen/hinzufuegen'
    | '/verkehrszeichen/$adminLevelId/$signSupportId/$signGroupId/bearbeiten'
    | '/verkehrszeichen/$adminLevelId/$signSupportId/$signGroupId/duplizieren'
    | '/verkehrszeichen/$adminLevelId/$signSupportId/$signGroupId/hinzufuegen'
    | '/verkehrszeichen/$adminLevelId/$signSupportId/$signGroupId/$signId'
    | '/verkehrszeichen/recherche/$signSupportId/$signGroupId/$signId'
    | '/verkehrszeichen/$adminLevelId/$signSupportId/$signGroupId/$signId/bearbeiten'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_authenticated/_management'
    | '/_authenticated/anordnung'
    | '/_authenticated/hilfe'
    | '/_authenticated/pruefung'
    | '/_authenticated/barrierefreiheit'
    | '/_authenticated/datenschutz'
    | '/_authenticated/impressum'
    | '/_authenticated/kontakt'
    | '/_authenticated/nutzungsbedingungen'
    | '/_authenticated/registrierung'
    | '/_authenticated/_management/administration'
    | '/_authenticated/_management/meine-organisation'
    | '/_authenticated/_management/verkehrszeichen'
    | '/_authenticated/_management/vorgaenge'
    | '/_authenticated/anordnung/$processId'
    | '/_authenticated/anordnung/success'
    | '/_authenticated/hilfe/benutzerverwaltung'
    | '/_authenticated/hilfe/datenschnittstellen'
    | '/_authenticated/hilfe/funktionsuebersicht'
    | '/_authenticated/hilfe/klickanleitungen'
    | '/_authenticated/hilfe/organisationsverwaltung'
    | '/_authenticated/hilfe/release-notes'
    | '/_authenticated/hilfe/verkehrszeichen-datenmodell'
    | '/_authenticated/hilfe/verkehrszeichen-edit'
    | '/_authenticated/hilfe/vorgaenge'
    | '/_authenticated/hilfe/'
    | '/_authenticated/_management/administration/benutzerinnen'
    | '/_authenticated/_management/administration/organisationen'
    | '/_authenticated/_management/administration/pruefroutinen'
    | '/_authenticated/_management/profil/edit'
    | '/_authenticated/_management/verkehrszeichen/$adminLevelId'
    | '/_authenticated/pruefung/$processId/$examinationId'
    | '/_authenticated/_management/profil/'
    | '/_authenticated/_management/verkehrszeichen/'
    | '/_authenticated/_management/vorgaenge/'
    | '/_authenticated/_management/administration/benutzerinnen/$userId'
    | '/_authenticated/_management/administration/organisationen/hinzufuegen'
    | '/_authenticated/_management/meine-organisation/benutzerinnen/$userId'
    | '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId'
    | '/_authenticated/_management/verkehrszeichen/$adminLevelId/hinzufuegen'
    | '/_authenticated/_management/verkehrszeichen/recherche/$signSupportId'
    | '/_authenticated/_management/administration/benutzerinnen/'
    | '/_authenticated/_management/administration/organisationen/'
    | '/_authenticated/_management/administration/pruefroutinen/'
    | '/_authenticated/_management/administration/verwaltungsebenen/'
    | '/_authenticated/_management/meine-organisation/benutzerinnen/'
    | '/_authenticated/_management/meine-organisation/importe/'
    | '/_authenticated/_management/meine-organisation/stakeholder/'
    | '/_authenticated/_management/meine-organisation/stammdaten/'
    | '/_authenticated/_management/verkehrszeichen/recherche/'
    | '/_authenticated/_management/vorgaenge/$adminLevelId/'
    | '/_authenticated/_management/vorgaenge/recherche/'
    | '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId/bearbeiten'
    | '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId/hinzufuegen'
    | '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId_/$signGroupId'
    | '/_authenticated/_management/verkehrszeichen/recherche/$signSupportId_/$signGroupId'
    | '/_authenticated/_management/vorgaenge/$adminLevelId/$processId/$examinationId'
    | '/_authenticated/_management/vorgaenge/$adminLevelId/$processId/edit'
    | '/_authenticated/_management/administration/organisationen/$organizationId/'
    | '/_authenticated/_management/administration/verwaltungsebenen/$adminLevelId/'
    | '/_authenticated/_management/vorgaenge/$adminLevelId/$processId/'
    | '/_authenticated/_management/vorgaenge/$adminLevelId/karte/'
    | '/_authenticated/_management/administration/benutzerinnen/$userId_/organisation/hinzufuegen'
    | '/_authenticated/_management/administration/organisationen/$organizationId/benutzerinnen/$userId'
    | '/_authenticated/_management/administration/organisationen/$organizationId/verwaltungsebenen/$adminLevelId'
    | '/_authenticated/_management/administration/verwaltungsebenen/$adminLevelId/organisationen/hinzufuegen'
    | '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId_/$signGroupId/bearbeiten'
    | '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId_/$signGroupId/duplizieren'
    | '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId_/$signGroupId/hinzufuegen'
    | '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId_/$signGroupId_/$signId'
    | '/_authenticated/_management/verkehrszeichen/recherche/$signSupportId_/$signGroupId_/$signId'
    | '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId_/$signGroupId_/$signId/bearbeiten'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_management': {
      id: '/_authenticated/_management'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedManagementRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/anordnung': {
      id: '/_authenticated/anordnung'
      path: '/anordnung'
      fullPath: '/anordnung'
      preLoaderRoute: typeof AuthenticatedAnordnungRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/barrierefreiheit': {
      id: '/_authenticated/barrierefreiheit'
      path: '/barrierefreiheit'
      fullPath: '/barrierefreiheit'
      preLoaderRoute: typeof AuthenticatedBarrierefreiheitRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/datenschutz': {
      id: '/_authenticated/datenschutz'
      path: '/datenschutz'
      fullPath: '/datenschutz'
      preLoaderRoute: typeof AuthenticatedDatenschutzRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/hilfe': {
      id: '/_authenticated/hilfe'
      path: '/hilfe'
      fullPath: '/hilfe'
      preLoaderRoute: typeof AuthenticatedHilfeRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/impressum': {
      id: '/_authenticated/impressum'
      path: '/impressum'
      fullPath: '/impressum'
      preLoaderRoute: typeof AuthenticatedImpressumRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/kontakt': {
      id: '/_authenticated/kontakt'
      path: '/kontakt'
      fullPath: '/kontakt'
      preLoaderRoute: typeof AuthenticatedKontaktRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/nutzungsbedingungen': {
      id: '/_authenticated/nutzungsbedingungen'
      path: '/nutzungsbedingungen'
      fullPath: '/nutzungsbedingungen'
      preLoaderRoute: typeof AuthenticatedNutzungsbedingungenRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/pruefung': {
      id: '/_authenticated/pruefung'
      path: '/pruefung'
      fullPath: '/pruefung'
      preLoaderRoute: typeof AuthenticatedPruefungRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/registrierung': {
      id: '/_authenticated/registrierung'
      path: '/registrierung'
      fullPath: '/registrierung'
      preLoaderRoute: typeof AuthenticatedRegistrierungRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/_management/administration': {
      id: '/_authenticated/_management/administration'
      path: '/administration'
      fullPath: '/administration'
      preLoaderRoute: typeof AuthenticatedManagementAdministrationRouteRouteImport
      parentRoute: typeof AuthenticatedManagementRouteRoute
    }
    '/_authenticated/_management/meine-organisation': {
      id: '/_authenticated/_management/meine-organisation'
      path: '/meine-organisation'
      fullPath: '/meine-organisation'
      preLoaderRoute: typeof AuthenticatedManagementMeineOrganisationRouteRouteImport
      parentRoute: typeof AuthenticatedManagementRouteRoute
    }
    '/_authenticated/_management/verkehrszeichen': {
      id: '/_authenticated/_management/verkehrszeichen'
      path: '/verkehrszeichen'
      fullPath: '/verkehrszeichen'
      preLoaderRoute: typeof AuthenticatedManagementVerkehrszeichenRouteRouteImport
      parentRoute: typeof AuthenticatedManagementRouteRoute
    }
    '/_authenticated/_management/vorgaenge': {
      id: '/_authenticated/_management/vorgaenge'
      path: '/vorgaenge'
      fullPath: '/vorgaenge'
      preLoaderRoute: typeof AuthenticatedManagementVorgaengeRouteRouteImport
      parentRoute: typeof AuthenticatedManagementRouteRoute
    }
    '/_authenticated/anordnung/$processId': {
      id: '/_authenticated/anordnung/$processId'
      path: '/$processId'
      fullPath: '/anordnung/$processId'
      preLoaderRoute: typeof AuthenticatedAnordnungProcessIdRouteImport
      parentRoute: typeof AuthenticatedAnordnungRouteRoute
    }
    '/_authenticated/anordnung/success': {
      id: '/_authenticated/anordnung/success'
      path: '/success'
      fullPath: '/anordnung/success'
      preLoaderRoute: typeof AuthenticatedAnordnungSuccessRouteImport
      parentRoute: typeof AuthenticatedAnordnungRouteRoute
    }
    '/_authenticated/hilfe/': {
      id: '/_authenticated/hilfe/'
      path: '/'
      fullPath: '/hilfe/'
      preLoaderRoute: typeof AuthenticatedHilfeIndexRouteImport
      parentRoute: typeof AuthenticatedHilfeRouteRoute
    }
    '/_authenticated/hilfe/benutzerverwaltung': {
      id: '/_authenticated/hilfe/benutzerverwaltung'
      path: '/benutzerverwaltung'
      fullPath: '/hilfe/benutzerverwaltung'
      preLoaderRoute: typeof AuthenticatedHilfeBenutzerverwaltungRouteImport
      parentRoute: typeof AuthenticatedHilfeRouteRoute
    }
    '/_authenticated/hilfe/datenschnittstellen': {
      id: '/_authenticated/hilfe/datenschnittstellen'
      path: '/datenschnittstellen'
      fullPath: '/hilfe/datenschnittstellen'
      preLoaderRoute: typeof AuthenticatedHilfeDatenschnittstellenRouteImport
      parentRoute: typeof AuthenticatedHilfeRouteRoute
    }
    '/_authenticated/hilfe/funktionsuebersicht': {
      id: '/_authenticated/hilfe/funktionsuebersicht'
      path: '/funktionsuebersicht'
      fullPath: '/hilfe/funktionsuebersicht'
      preLoaderRoute: typeof AuthenticatedHilfeFunktionsuebersichtRouteImport
      parentRoute: typeof AuthenticatedHilfeRouteRoute
    }
    '/_authenticated/hilfe/klickanleitungen': {
      id: '/_authenticated/hilfe/klickanleitungen'
      path: '/klickanleitungen'
      fullPath: '/hilfe/klickanleitungen'
      preLoaderRoute: typeof AuthenticatedHilfeKlickanleitungenRouteImport
      parentRoute: typeof AuthenticatedHilfeRouteRoute
    }
    '/_authenticated/hilfe/organisationsverwaltung': {
      id: '/_authenticated/hilfe/organisationsverwaltung'
      path: '/organisationsverwaltung'
      fullPath: '/hilfe/organisationsverwaltung'
      preLoaderRoute: typeof AuthenticatedHilfeOrganisationsverwaltungRouteImport
      parentRoute: typeof AuthenticatedHilfeRouteRoute
    }
    '/_authenticated/hilfe/release-notes': {
      id: '/_authenticated/hilfe/release-notes'
      path: '/release-notes'
      fullPath: '/hilfe/release-notes'
      preLoaderRoute: typeof AuthenticatedHilfeReleaseNotesRouteImport
      parentRoute: typeof AuthenticatedHilfeRouteRoute
    }
    '/_authenticated/hilfe/verkehrszeichen-datenmodell': {
      id: '/_authenticated/hilfe/verkehrszeichen-datenmodell'
      path: '/verkehrszeichen-datenmodell'
      fullPath: '/hilfe/verkehrszeichen-datenmodell'
      preLoaderRoute: typeof AuthenticatedHilfeVerkehrszeichenDatenmodellRouteImport
      parentRoute: typeof AuthenticatedHilfeRouteRoute
    }
    '/_authenticated/hilfe/verkehrszeichen-edit': {
      id: '/_authenticated/hilfe/verkehrszeichen-edit'
      path: '/verkehrszeichen-edit'
      fullPath: '/hilfe/verkehrszeichen-edit'
      preLoaderRoute: typeof AuthenticatedHilfeVerkehrszeichenEditRouteImport
      parentRoute: typeof AuthenticatedHilfeRouteRoute
    }
    '/_authenticated/hilfe/vorgaenge': {
      id: '/_authenticated/hilfe/vorgaenge'
      path: '/vorgaenge'
      fullPath: '/hilfe/vorgaenge'
      preLoaderRoute: typeof AuthenticatedHilfeVorgaengeRouteImport
      parentRoute: typeof AuthenticatedHilfeRouteRoute
    }
    '/_authenticated/_management/administration/benutzerinnen': {
      id: '/_authenticated/_management/administration/benutzerinnen'
      path: '/benutzerinnen'
      fullPath: '/administration/benutzerinnen'
      preLoaderRoute: typeof AuthenticatedManagementAdministrationBenutzerinnenRouteRouteImport
      parentRoute: typeof AuthenticatedManagementAdministrationRouteRoute
    }
    '/_authenticated/_management/administration/organisationen': {
      id: '/_authenticated/_management/administration/organisationen'
      path: '/organisationen'
      fullPath: '/administration/organisationen'
      preLoaderRoute: typeof AuthenticatedManagementAdministrationOrganisationenRouteRouteImport
      parentRoute: typeof AuthenticatedManagementAdministrationRouteRoute
    }
    '/_authenticated/_management/administration/pruefroutinen': {
      id: '/_authenticated/_management/administration/pruefroutinen'
      path: '/pruefroutinen'
      fullPath: '/administration/pruefroutinen'
      preLoaderRoute: typeof AuthenticatedManagementAdministrationPruefroutinenRouteRouteImport
      parentRoute: typeof AuthenticatedManagementAdministrationRouteRoute
    }
    '/_authenticated/_management/profil/': {
      id: '/_authenticated/_management/profil/'
      path: '/profil'
      fullPath: '/profil/'
      preLoaderRoute: typeof AuthenticatedManagementProfilIndexRouteImport
      parentRoute: typeof AuthenticatedManagementRouteRoute
    }
    '/_authenticated/_management/profil/edit': {
      id: '/_authenticated/_management/profil/edit'
      path: '/profil/edit'
      fullPath: '/profil/edit'
      preLoaderRoute: typeof AuthenticatedManagementProfilEditRouteImport
      parentRoute: typeof AuthenticatedManagementRouteRoute
    }
    '/_authenticated/_management/verkehrszeichen/': {
      id: '/_authenticated/_management/verkehrszeichen/'
      path: '/'
      fullPath: '/verkehrszeichen/'
      preLoaderRoute: typeof AuthenticatedManagementVerkehrszeichenIndexRouteImport
      parentRoute: typeof AuthenticatedManagementVerkehrszeichenRouteRoute
    }
    '/_authenticated/_management/verkehrszeichen/$adminLevelId': {
      id: '/_authenticated/_management/verkehrszeichen/$adminLevelId'
      path: '/$adminLevelId'
      fullPath: '/verkehrszeichen/$adminLevelId'
      preLoaderRoute: typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdRouteImport
      parentRoute: typeof AuthenticatedManagementVerkehrszeichenRouteRoute
    }
    '/_authenticated/_management/vorgaenge/': {
      id: '/_authenticated/_management/vorgaenge/'
      path: '/'
      fullPath: '/vorgaenge/'
      preLoaderRoute: typeof AuthenticatedManagementVorgaengeIndexRouteImport
      parentRoute: typeof AuthenticatedManagementVorgaengeRouteRoute
    }
    '/_authenticated/pruefung/$processId/$examinationId': {
      id: '/_authenticated/pruefung/$processId/$examinationId'
      path: '/$processId/$examinationId'
      fullPath: '/pruefung/$processId/$examinationId'
      preLoaderRoute: typeof AuthenticatedPruefungProcessIdExaminationIdRouteImport
      parentRoute: typeof AuthenticatedPruefungRouteRoute
    }
    '/_authenticated/_management/administration/benutzerinnen/': {
      id: '/_authenticated/_management/administration/benutzerinnen/'
      path: '/'
      fullPath: '/administration/benutzerinnen/'
      preLoaderRoute: typeof AuthenticatedManagementAdministrationBenutzerinnenIndexRouteImport
      parentRoute: typeof AuthenticatedManagementAdministrationBenutzerinnenRouteRoute
    }
    '/_authenticated/_management/administration/benutzerinnen/$userId': {
      id: '/_authenticated/_management/administration/benutzerinnen/$userId'
      path: '/$userId'
      fullPath: '/administration/benutzerinnen/$userId'
      preLoaderRoute: typeof AuthenticatedManagementAdministrationBenutzerinnenUserIdRouteImport
      parentRoute: typeof AuthenticatedManagementAdministrationBenutzerinnenRouteRoute
    }
    '/_authenticated/_management/administration/organisationen/': {
      id: '/_authenticated/_management/administration/organisationen/'
      path: '/'
      fullPath: '/administration/organisationen/'
      preLoaderRoute: typeof AuthenticatedManagementAdministrationOrganisationenIndexRouteImport
      parentRoute: typeof AuthenticatedManagementAdministrationOrganisationenRouteRoute
    }
    '/_authenticated/_management/administration/organisationen/hinzufuegen': {
      id: '/_authenticated/_management/administration/organisationen/hinzufuegen'
      path: '/hinzufuegen'
      fullPath: '/administration/organisationen/hinzufuegen'
      preLoaderRoute: typeof AuthenticatedManagementAdministrationOrganisationenHinzufuegenRouteImport
      parentRoute: typeof AuthenticatedManagementAdministrationOrganisationenRouteRoute
    }
    '/_authenticated/_management/administration/pruefroutinen/': {
      id: '/_authenticated/_management/administration/pruefroutinen/'
      path: '/'
      fullPath: '/administration/pruefroutinen/'
      preLoaderRoute: typeof AuthenticatedManagementAdministrationPruefroutinenIndexRouteImport
      parentRoute: typeof AuthenticatedManagementAdministrationPruefroutinenRouteRoute
    }
    '/_authenticated/_management/administration/verwaltungsebenen/': {
      id: '/_authenticated/_management/administration/verwaltungsebenen/'
      path: '/verwaltungsebenen'
      fullPath: '/administration/verwaltungsebenen/'
      preLoaderRoute: typeof AuthenticatedManagementAdministrationVerwaltungsebenenIndexRouteImport
      parentRoute: typeof AuthenticatedManagementAdministrationRouteRoute
    }
    '/_authenticated/_management/meine-organisation/benutzerinnen/': {
      id: '/_authenticated/_management/meine-organisation/benutzerinnen/'
      path: '/benutzerinnen'
      fullPath: '/meine-organisation/benutzerinnen/'
      preLoaderRoute: typeof AuthenticatedManagementMeineOrganisationBenutzerinnenIndexRouteImport
      parentRoute: typeof AuthenticatedManagementMeineOrganisationRouteRoute
    }
    '/_authenticated/_management/meine-organisation/benutzerinnen/$userId': {
      id: '/_authenticated/_management/meine-organisation/benutzerinnen/$userId'
      path: '/benutzerinnen/$userId'
      fullPath: '/meine-organisation/benutzerinnen/$userId'
      preLoaderRoute: typeof AuthenticatedManagementMeineOrganisationBenutzerinnenUserIdRouteImport
      parentRoute: typeof AuthenticatedManagementMeineOrganisationRouteRoute
    }
    '/_authenticated/_management/meine-organisation/importe/': {
      id: '/_authenticated/_management/meine-organisation/importe/'
      path: '/importe'
      fullPath: '/meine-organisation/importe/'
      preLoaderRoute: typeof AuthenticatedManagementMeineOrganisationImporteIndexRouteImport
      parentRoute: typeof AuthenticatedManagementMeineOrganisationRouteRoute
    }
    '/_authenticated/_management/meine-organisation/stakeholder/': {
      id: '/_authenticated/_management/meine-organisation/stakeholder/'
      path: '/stakeholder'
      fullPath: '/meine-organisation/stakeholder/'
      preLoaderRoute: typeof AuthenticatedManagementMeineOrganisationStakeholderIndexRouteImport
      parentRoute: typeof AuthenticatedManagementMeineOrganisationRouteRoute
    }
    '/_authenticated/_management/meine-organisation/stammdaten/': {
      id: '/_authenticated/_management/meine-organisation/stammdaten/'
      path: '/stammdaten'
      fullPath: '/meine-organisation/stammdaten/'
      preLoaderRoute: typeof AuthenticatedManagementMeineOrganisationStammdatenIndexRouteImport
      parentRoute: typeof AuthenticatedManagementMeineOrganisationRouteRoute
    }
    '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId': {
      id: '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId'
      path: '/$signSupportId'
      fullPath: '/verkehrszeichen/$adminLevelId/$signSupportId'
      preLoaderRoute: typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdRouteImport
      parentRoute: typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdRoute
    }
    '/_authenticated/_management/verkehrszeichen/$adminLevelId/hinzufuegen': {
      id: '/_authenticated/_management/verkehrszeichen/$adminLevelId/hinzufuegen'
      path: '/hinzufuegen'
      fullPath: '/verkehrszeichen/$adminLevelId/hinzufuegen'
      preLoaderRoute: typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdHinzufuegenRouteImport
      parentRoute: typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdRoute
    }
    '/_authenticated/_management/verkehrszeichen/recherche/': {
      id: '/_authenticated/_management/verkehrszeichen/recherche/'
      path: '/recherche'
      fullPath: '/verkehrszeichen/recherche/'
      preLoaderRoute: typeof AuthenticatedManagementVerkehrszeichenRechercheIndexRouteImport
      parentRoute: typeof AuthenticatedManagementVerkehrszeichenRouteRoute
    }
    '/_authenticated/_management/verkehrszeichen/recherche/$signSupportId': {
      id: '/_authenticated/_management/verkehrszeichen/recherche/$signSupportId'
      path: '/recherche/$signSupportId'
      fullPath: '/verkehrszeichen/recherche/$signSupportId'
      preLoaderRoute: typeof AuthenticatedManagementVerkehrszeichenRechercheSignSupportIdRouteImport
      parentRoute: typeof AuthenticatedManagementVerkehrszeichenRouteRoute
    }
    '/_authenticated/_management/vorgaenge/$adminLevelId/': {
      id: '/_authenticated/_management/vorgaenge/$adminLevelId/'
      path: '/$adminLevelId'
      fullPath: '/vorgaenge/$adminLevelId/'
      preLoaderRoute: typeof AuthenticatedManagementVorgaengeAdminLevelIdIndexRouteImport
      parentRoute: typeof AuthenticatedManagementVorgaengeRouteRoute
    }
    '/_authenticated/_management/vorgaenge/recherche/': {
      id: '/_authenticated/_management/vorgaenge/recherche/'
      path: '/recherche'
      fullPath: '/vorgaenge/recherche/'
      preLoaderRoute: typeof AuthenticatedManagementVorgaengeRechercheIndexRouteImport
      parentRoute: typeof AuthenticatedManagementVorgaengeRouteRoute
    }
    '/_authenticated/_management/administration/organisationen/$organizationId/': {
      id: '/_authenticated/_management/administration/organisationen/$organizationId/'
      path: '/$organizationId'
      fullPath: '/administration/organisationen/$organizationId/'
      preLoaderRoute: typeof AuthenticatedManagementAdministrationOrganisationenOrganizationIdIndexRouteImport
      parentRoute: typeof AuthenticatedManagementAdministrationOrganisationenRouteRoute
    }
    '/_authenticated/_management/administration/verwaltungsebenen/$adminLevelId/': {
      id: '/_authenticated/_management/administration/verwaltungsebenen/$adminLevelId/'
      path: '/verwaltungsebenen/$adminLevelId'
      fullPath: '/administration/verwaltungsebenen/$adminLevelId/'
      preLoaderRoute: typeof AuthenticatedManagementAdministrationVerwaltungsebenenAdminLevelIdIndexRouteImport
      parentRoute: typeof AuthenticatedManagementAdministrationRouteRoute
    }
    '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId/bearbeiten': {
      id: '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId/bearbeiten'
      path: '/bearbeiten'
      fullPath: '/verkehrszeichen/$adminLevelId/$signSupportId/bearbeiten'
      preLoaderRoute: typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdBearbeitenRouteImport
      parentRoute: typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdRoute
    }
    '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId/hinzufuegen': {
      id: '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId/hinzufuegen'
      path: '/hinzufuegen'
      fullPath: '/verkehrszeichen/$adminLevelId/$signSupportId/hinzufuegen'
      preLoaderRoute: typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdHinzufuegenRouteImport
      parentRoute: typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdRoute
    }
    '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId_/$signGroupId': {
      id: '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId_/$signGroupId'
      path: '/$signSupportId/$signGroupId'
      fullPath: '/verkehrszeichen/$adminLevelId/$signSupportId/$signGroupId'
      preLoaderRoute: typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdRouteImport
      parentRoute: typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdRoute
    }
    '/_authenticated/_management/verkehrszeichen/recherche/$signSupportId_/$signGroupId': {
      id: '/_authenticated/_management/verkehrszeichen/recherche/$signSupportId_/$signGroupId'
      path: '/recherche/$signSupportId/$signGroupId'
      fullPath: '/verkehrszeichen/recherche/$signSupportId/$signGroupId'
      preLoaderRoute: typeof AuthenticatedManagementVerkehrszeichenRechercheSignSupportIdSignGroupIdRouteImport
      parentRoute: typeof AuthenticatedManagementVerkehrszeichenRouteRoute
    }
    '/_authenticated/_management/vorgaenge/$adminLevelId/$processId/': {
      id: '/_authenticated/_management/vorgaenge/$adminLevelId/$processId/'
      path: '/$adminLevelId/$processId'
      fullPath: '/vorgaenge/$adminLevelId/$processId/'
      preLoaderRoute: typeof AuthenticatedManagementVorgaengeAdminLevelIdProcessIdIndexRouteImport
      parentRoute: typeof AuthenticatedManagementVorgaengeRouteRoute
    }
    '/_authenticated/_management/vorgaenge/$adminLevelId/$processId/$examinationId': {
      id: '/_authenticated/_management/vorgaenge/$adminLevelId/$processId/$examinationId'
      path: '/$adminLevelId/$processId/$examinationId'
      fullPath: '/vorgaenge/$adminLevelId/$processId/$examinationId'
      preLoaderRoute: typeof AuthenticatedManagementVorgaengeAdminLevelIdProcessIdExaminationIdRouteImport
      parentRoute: typeof AuthenticatedManagementVorgaengeRouteRoute
    }
    '/_authenticated/_management/vorgaenge/$adminLevelId/$processId/edit': {
      id: '/_authenticated/_management/vorgaenge/$adminLevelId/$processId/edit'
      path: '/$adminLevelId/$processId/edit'
      fullPath: '/vorgaenge/$adminLevelId/$processId/edit'
      preLoaderRoute: typeof AuthenticatedManagementVorgaengeAdminLevelIdProcessIdEditRouteImport
      parentRoute: typeof AuthenticatedManagementVorgaengeRouteRoute
    }
    '/_authenticated/_management/vorgaenge/$adminLevelId/karte/': {
      id: '/_authenticated/_management/vorgaenge/$adminLevelId/karte/'
      path: '/$adminLevelId/karte'
      fullPath: '/vorgaenge/$adminLevelId/karte/'
      preLoaderRoute: typeof AuthenticatedManagementVorgaengeAdminLevelIdKarteIndexRouteImport
      parentRoute: typeof AuthenticatedManagementVorgaengeRouteRoute
    }
    '/_authenticated/_management/administration/benutzerinnen/$userId_/organisation/hinzufuegen': {
      id: '/_authenticated/_management/administration/benutzerinnen/$userId_/organisation/hinzufuegen'
      path: '/$userId/organisation/hinzufuegen'
      fullPath: '/administration/benutzerinnen/$userId/organisation/hinzufuegen'
      preLoaderRoute: typeof AuthenticatedManagementAdministrationBenutzerinnenUserIdOrganisationHinzufuegenRouteImport
      parentRoute: typeof AuthenticatedManagementAdministrationBenutzerinnenRouteRoute
    }
    '/_authenticated/_management/administration/organisationen/$organizationId/benutzerinnen/$userId': {
      id: '/_authenticated/_management/administration/organisationen/$organizationId/benutzerinnen/$userId'
      path: '/$organizationId/benutzerinnen/$userId'
      fullPath: '/administration/organisationen/$organizationId/benutzerinnen/$userId'
      preLoaderRoute: typeof AuthenticatedManagementAdministrationOrganisationenOrganizationIdBenutzerinnenUserIdRouteImport
      parentRoute: typeof AuthenticatedManagementAdministrationOrganisationenRouteRoute
    }
    '/_authenticated/_management/administration/organisationen/$organizationId/verwaltungsebenen/$adminLevelId': {
      id: '/_authenticated/_management/administration/organisationen/$organizationId/verwaltungsebenen/$adminLevelId'
      path: '/$organizationId/verwaltungsebenen/$adminLevelId'
      fullPath: '/administration/organisationen/$organizationId/verwaltungsebenen/$adminLevelId'
      preLoaderRoute: typeof AuthenticatedManagementAdministrationOrganisationenOrganizationIdVerwaltungsebenenAdminLevelIdRouteImport
      parentRoute: typeof AuthenticatedManagementAdministrationOrganisationenRouteRoute
    }
    '/_authenticated/_management/administration/verwaltungsebenen/$adminLevelId/organisationen/hinzufuegen': {
      id: '/_authenticated/_management/administration/verwaltungsebenen/$adminLevelId/organisationen/hinzufuegen'
      path: '/verwaltungsebenen/$adminLevelId/organisationen/hinzufuegen'
      fullPath: '/administration/verwaltungsebenen/$adminLevelId/organisationen/hinzufuegen'
      preLoaderRoute: typeof AuthenticatedManagementAdministrationVerwaltungsebenenAdminLevelIdOrganisationenHinzufuegenRouteImport
      parentRoute: typeof AuthenticatedManagementAdministrationRouteRoute
    }
    '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId_/$signGroupId/bearbeiten': {
      id: '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId_/$signGroupId/bearbeiten'
      path: '/bearbeiten'
      fullPath: '/verkehrszeichen/$adminLevelId/$signSupportId/$signGroupId/bearbeiten'
      preLoaderRoute: typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdBearbeitenRouteImport
      parentRoute: typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdRoute
    }
    '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId_/$signGroupId/duplizieren': {
      id: '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId_/$signGroupId/duplizieren'
      path: '/duplizieren'
      fullPath: '/verkehrszeichen/$adminLevelId/$signSupportId/$signGroupId/duplizieren'
      preLoaderRoute: typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdDuplizierenRouteImport
      parentRoute: typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdRoute
    }
    '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId_/$signGroupId/hinzufuegen': {
      id: '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId_/$signGroupId/hinzufuegen'
      path: '/hinzufuegen'
      fullPath: '/verkehrszeichen/$adminLevelId/$signSupportId/$signGroupId/hinzufuegen'
      preLoaderRoute: typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdHinzufuegenRouteImport
      parentRoute: typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdRoute
    }
    '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId_/$signGroupId_/$signId': {
      id: '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId_/$signGroupId_/$signId'
      path: '/$signSupportId/$signGroupId/$signId'
      fullPath: '/verkehrszeichen/$adminLevelId/$signSupportId/$signGroupId/$signId'
      preLoaderRoute: typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdSignIdRouteImport
      parentRoute: typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdRoute
    }
    '/_authenticated/_management/verkehrszeichen/recherche/$signSupportId_/$signGroupId_/$signId': {
      id: '/_authenticated/_management/verkehrszeichen/recherche/$signSupportId_/$signGroupId_/$signId'
      path: '/recherche/$signSupportId/$signGroupId/$signId'
      fullPath: '/verkehrszeichen/recherche/$signSupportId/$signGroupId/$signId'
      preLoaderRoute: typeof AuthenticatedManagementVerkehrszeichenRechercheSignSupportIdSignGroupIdSignIdRouteImport
      parentRoute: typeof AuthenticatedManagementVerkehrszeichenRouteRoute
    }
    '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId_/$signGroupId_/$signId/bearbeiten': {
      id: '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId_/$signGroupId_/$signId/bearbeiten'
      path: '/bearbeiten'
      fullPath: '/verkehrszeichen/$adminLevelId/$signSupportId/$signGroupId/$signId/bearbeiten'
      preLoaderRoute: typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdSignIdBearbeitenRouteImport
      parentRoute: typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdSignIdRoute
    }
  }
}

interface AuthenticatedManagementAdministrationBenutzerinnenRouteRouteChildren {
  AuthenticatedManagementAdministrationBenutzerinnenUserIdRoute: typeof AuthenticatedManagementAdministrationBenutzerinnenUserIdRoute
  AuthenticatedManagementAdministrationBenutzerinnenIndexRoute: typeof AuthenticatedManagementAdministrationBenutzerinnenIndexRoute
  AuthenticatedManagementAdministrationBenutzerinnenUserIdOrganisationHinzufuegenRoute: typeof AuthenticatedManagementAdministrationBenutzerinnenUserIdOrganisationHinzufuegenRoute
}

const AuthenticatedManagementAdministrationBenutzerinnenRouteRouteChildren: AuthenticatedManagementAdministrationBenutzerinnenRouteRouteChildren =
  {
    AuthenticatedManagementAdministrationBenutzerinnenUserIdRoute:
      AuthenticatedManagementAdministrationBenutzerinnenUserIdRoute,
    AuthenticatedManagementAdministrationBenutzerinnenIndexRoute:
      AuthenticatedManagementAdministrationBenutzerinnenIndexRoute,
    AuthenticatedManagementAdministrationBenutzerinnenUserIdOrganisationHinzufuegenRoute:
      AuthenticatedManagementAdministrationBenutzerinnenUserIdOrganisationHinzufuegenRoute,
  }

const AuthenticatedManagementAdministrationBenutzerinnenRouteRouteWithChildren =
  AuthenticatedManagementAdministrationBenutzerinnenRouteRoute._addFileChildren(
    AuthenticatedManagementAdministrationBenutzerinnenRouteRouteChildren,
  )

interface AuthenticatedManagementAdministrationOrganisationenRouteRouteChildren {
  AuthenticatedManagementAdministrationOrganisationenHinzufuegenRoute: typeof AuthenticatedManagementAdministrationOrganisationenHinzufuegenRoute
  AuthenticatedManagementAdministrationOrganisationenIndexRoute: typeof AuthenticatedManagementAdministrationOrganisationenIndexRoute
  AuthenticatedManagementAdministrationOrganisationenOrganizationIdIndexRoute: typeof AuthenticatedManagementAdministrationOrganisationenOrganizationIdIndexRoute
  AuthenticatedManagementAdministrationOrganisationenOrganizationIdBenutzerinnenUserIdRoute: typeof AuthenticatedManagementAdministrationOrganisationenOrganizationIdBenutzerinnenUserIdRoute
  AuthenticatedManagementAdministrationOrganisationenOrganizationIdVerwaltungsebenenAdminLevelIdRoute: typeof AuthenticatedManagementAdministrationOrganisationenOrganizationIdVerwaltungsebenenAdminLevelIdRoute
}

const AuthenticatedManagementAdministrationOrganisationenRouteRouteChildren: AuthenticatedManagementAdministrationOrganisationenRouteRouteChildren =
  {
    AuthenticatedManagementAdministrationOrganisationenHinzufuegenRoute:
      AuthenticatedManagementAdministrationOrganisationenHinzufuegenRoute,
    AuthenticatedManagementAdministrationOrganisationenIndexRoute:
      AuthenticatedManagementAdministrationOrganisationenIndexRoute,
    AuthenticatedManagementAdministrationOrganisationenOrganizationIdIndexRoute:
      AuthenticatedManagementAdministrationOrganisationenOrganizationIdIndexRoute,
    AuthenticatedManagementAdministrationOrganisationenOrganizationIdBenutzerinnenUserIdRoute:
      AuthenticatedManagementAdministrationOrganisationenOrganizationIdBenutzerinnenUserIdRoute,
    AuthenticatedManagementAdministrationOrganisationenOrganizationIdVerwaltungsebenenAdminLevelIdRoute:
      AuthenticatedManagementAdministrationOrganisationenOrganizationIdVerwaltungsebenenAdminLevelIdRoute,
  }

const AuthenticatedManagementAdministrationOrganisationenRouteRouteWithChildren =
  AuthenticatedManagementAdministrationOrganisationenRouteRoute._addFileChildren(
    AuthenticatedManagementAdministrationOrganisationenRouteRouteChildren,
  )

interface AuthenticatedManagementAdministrationPruefroutinenRouteRouteChildren {
  AuthenticatedManagementAdministrationPruefroutinenIndexRoute: typeof AuthenticatedManagementAdministrationPruefroutinenIndexRoute
}

const AuthenticatedManagementAdministrationPruefroutinenRouteRouteChildren: AuthenticatedManagementAdministrationPruefroutinenRouteRouteChildren =
  {
    AuthenticatedManagementAdministrationPruefroutinenIndexRoute:
      AuthenticatedManagementAdministrationPruefroutinenIndexRoute,
  }

const AuthenticatedManagementAdministrationPruefroutinenRouteRouteWithChildren =
  AuthenticatedManagementAdministrationPruefroutinenRouteRoute._addFileChildren(
    AuthenticatedManagementAdministrationPruefroutinenRouteRouteChildren,
  )

interface AuthenticatedManagementAdministrationRouteRouteChildren {
  AuthenticatedManagementAdministrationBenutzerinnenRouteRoute: typeof AuthenticatedManagementAdministrationBenutzerinnenRouteRouteWithChildren
  AuthenticatedManagementAdministrationOrganisationenRouteRoute: typeof AuthenticatedManagementAdministrationOrganisationenRouteRouteWithChildren
  AuthenticatedManagementAdministrationPruefroutinenRouteRoute: typeof AuthenticatedManagementAdministrationPruefroutinenRouteRouteWithChildren
  AuthenticatedManagementAdministrationVerwaltungsebenenIndexRoute: typeof AuthenticatedManagementAdministrationVerwaltungsebenenIndexRoute
  AuthenticatedManagementAdministrationVerwaltungsebenenAdminLevelIdIndexRoute: typeof AuthenticatedManagementAdministrationVerwaltungsebenenAdminLevelIdIndexRoute
  AuthenticatedManagementAdministrationVerwaltungsebenenAdminLevelIdOrganisationenHinzufuegenRoute: typeof AuthenticatedManagementAdministrationVerwaltungsebenenAdminLevelIdOrganisationenHinzufuegenRoute
}

const AuthenticatedManagementAdministrationRouteRouteChildren: AuthenticatedManagementAdministrationRouteRouteChildren =
  {
    AuthenticatedManagementAdministrationBenutzerinnenRouteRoute:
      AuthenticatedManagementAdministrationBenutzerinnenRouteRouteWithChildren,
    AuthenticatedManagementAdministrationOrganisationenRouteRoute:
      AuthenticatedManagementAdministrationOrganisationenRouteRouteWithChildren,
    AuthenticatedManagementAdministrationPruefroutinenRouteRoute:
      AuthenticatedManagementAdministrationPruefroutinenRouteRouteWithChildren,
    AuthenticatedManagementAdministrationVerwaltungsebenenIndexRoute:
      AuthenticatedManagementAdministrationVerwaltungsebenenIndexRoute,
    AuthenticatedManagementAdministrationVerwaltungsebenenAdminLevelIdIndexRoute:
      AuthenticatedManagementAdministrationVerwaltungsebenenAdminLevelIdIndexRoute,
    AuthenticatedManagementAdministrationVerwaltungsebenenAdminLevelIdOrganisationenHinzufuegenRoute:
      AuthenticatedManagementAdministrationVerwaltungsebenenAdminLevelIdOrganisationenHinzufuegenRoute,
  }

const AuthenticatedManagementAdministrationRouteRouteWithChildren =
  AuthenticatedManagementAdministrationRouteRoute._addFileChildren(
    AuthenticatedManagementAdministrationRouteRouteChildren,
  )

interface AuthenticatedManagementMeineOrganisationRouteRouteChildren {
  AuthenticatedManagementMeineOrganisationBenutzerinnenUserIdRoute: typeof AuthenticatedManagementMeineOrganisationBenutzerinnenUserIdRoute
  AuthenticatedManagementMeineOrganisationBenutzerinnenIndexRoute: typeof AuthenticatedManagementMeineOrganisationBenutzerinnenIndexRoute
  AuthenticatedManagementMeineOrganisationImporteIndexRoute: typeof AuthenticatedManagementMeineOrganisationImporteIndexRoute
  AuthenticatedManagementMeineOrganisationStakeholderIndexRoute: typeof AuthenticatedManagementMeineOrganisationStakeholderIndexRoute
  AuthenticatedManagementMeineOrganisationStammdatenIndexRoute: typeof AuthenticatedManagementMeineOrganisationStammdatenIndexRoute
}

const AuthenticatedManagementMeineOrganisationRouteRouteChildren: AuthenticatedManagementMeineOrganisationRouteRouteChildren =
  {
    AuthenticatedManagementMeineOrganisationBenutzerinnenUserIdRoute:
      AuthenticatedManagementMeineOrganisationBenutzerinnenUserIdRoute,
    AuthenticatedManagementMeineOrganisationBenutzerinnenIndexRoute:
      AuthenticatedManagementMeineOrganisationBenutzerinnenIndexRoute,
    AuthenticatedManagementMeineOrganisationImporteIndexRoute:
      AuthenticatedManagementMeineOrganisationImporteIndexRoute,
    AuthenticatedManagementMeineOrganisationStakeholderIndexRoute:
      AuthenticatedManagementMeineOrganisationStakeholderIndexRoute,
    AuthenticatedManagementMeineOrganisationStammdatenIndexRoute:
      AuthenticatedManagementMeineOrganisationStammdatenIndexRoute,
  }

const AuthenticatedManagementMeineOrganisationRouteRouteWithChildren =
  AuthenticatedManagementMeineOrganisationRouteRoute._addFileChildren(
    AuthenticatedManagementMeineOrganisationRouteRouteChildren,
  )

interface AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdRouteChildren {
  AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdBearbeitenRoute: typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdBearbeitenRoute
  AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdHinzufuegenRoute: typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdHinzufuegenRoute
}

const AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdRouteChildren: AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdRouteChildren =
  {
    AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdBearbeitenRoute:
      AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdBearbeitenRoute,
    AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdHinzufuegenRoute:
      AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdHinzufuegenRoute,
  }

const AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdRouteWithChildren =
  AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdRoute._addFileChildren(
    AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdRouteChildren,
  )

interface AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdRouteChildren {
  AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdBearbeitenRoute: typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdBearbeitenRoute
  AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdDuplizierenRoute: typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdDuplizierenRoute
  AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdHinzufuegenRoute: typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdHinzufuegenRoute
}

const AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdRouteChildren: AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdRouteChildren =
  {
    AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdBearbeitenRoute:
      AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdBearbeitenRoute,
    AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdDuplizierenRoute:
      AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdDuplizierenRoute,
    AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdHinzufuegenRoute:
      AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdHinzufuegenRoute,
  }

const AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdRouteWithChildren =
  AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdRoute._addFileChildren(
    AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdRouteChildren,
  )

interface AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdSignIdRouteChildren {
  AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdSignIdBearbeitenRoute: typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdSignIdBearbeitenRoute
}

const AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdSignIdRouteChildren: AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdSignIdRouteChildren =
  {
    AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdSignIdBearbeitenRoute:
      AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdSignIdBearbeitenRoute,
  }

const AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdSignIdRouteWithChildren =
  AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdSignIdRoute._addFileChildren(
    AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdSignIdRouteChildren,
  )

interface AuthenticatedManagementVerkehrszeichenAdminLevelIdRouteChildren {
  AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdRoute: typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdRouteWithChildren
  AuthenticatedManagementVerkehrszeichenAdminLevelIdHinzufuegenRoute: typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdHinzufuegenRoute
  AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdRoute: typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdRouteWithChildren
  AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdSignIdRoute: typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdSignIdRouteWithChildren
}

const AuthenticatedManagementVerkehrszeichenAdminLevelIdRouteChildren: AuthenticatedManagementVerkehrszeichenAdminLevelIdRouteChildren =
  {
    AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdRoute:
      AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdRouteWithChildren,
    AuthenticatedManagementVerkehrszeichenAdminLevelIdHinzufuegenRoute:
      AuthenticatedManagementVerkehrszeichenAdminLevelIdHinzufuegenRoute,
    AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdRoute:
      AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdRouteWithChildren,
    AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdSignIdRoute:
      AuthenticatedManagementVerkehrszeichenAdminLevelIdSignSupportIdSignGroupIdSignIdRouteWithChildren,
  }

const AuthenticatedManagementVerkehrszeichenAdminLevelIdRouteWithChildren =
  AuthenticatedManagementVerkehrszeichenAdminLevelIdRoute._addFileChildren(
    AuthenticatedManagementVerkehrszeichenAdminLevelIdRouteChildren,
  )

interface AuthenticatedManagementVerkehrszeichenRouteRouteChildren {
  AuthenticatedManagementVerkehrszeichenAdminLevelIdRoute: typeof AuthenticatedManagementVerkehrszeichenAdminLevelIdRouteWithChildren
  AuthenticatedManagementVerkehrszeichenIndexRoute: typeof AuthenticatedManagementVerkehrszeichenIndexRoute
  AuthenticatedManagementVerkehrszeichenRechercheSignSupportIdRoute: typeof AuthenticatedManagementVerkehrszeichenRechercheSignSupportIdRoute
  AuthenticatedManagementVerkehrszeichenRechercheIndexRoute: typeof AuthenticatedManagementVerkehrszeichenRechercheIndexRoute
  AuthenticatedManagementVerkehrszeichenRechercheSignSupportIdSignGroupIdRoute: typeof AuthenticatedManagementVerkehrszeichenRechercheSignSupportIdSignGroupIdRoute
  AuthenticatedManagementVerkehrszeichenRechercheSignSupportIdSignGroupIdSignIdRoute: typeof AuthenticatedManagementVerkehrszeichenRechercheSignSupportIdSignGroupIdSignIdRoute
}

const AuthenticatedManagementVerkehrszeichenRouteRouteChildren: AuthenticatedManagementVerkehrszeichenRouteRouteChildren =
  {
    AuthenticatedManagementVerkehrszeichenAdminLevelIdRoute:
      AuthenticatedManagementVerkehrszeichenAdminLevelIdRouteWithChildren,
    AuthenticatedManagementVerkehrszeichenIndexRoute:
      AuthenticatedManagementVerkehrszeichenIndexRoute,
    AuthenticatedManagementVerkehrszeichenRechercheSignSupportIdRoute:
      AuthenticatedManagementVerkehrszeichenRechercheSignSupportIdRoute,
    AuthenticatedManagementVerkehrszeichenRechercheIndexRoute:
      AuthenticatedManagementVerkehrszeichenRechercheIndexRoute,
    AuthenticatedManagementVerkehrszeichenRechercheSignSupportIdSignGroupIdRoute:
      AuthenticatedManagementVerkehrszeichenRechercheSignSupportIdSignGroupIdRoute,
    AuthenticatedManagementVerkehrszeichenRechercheSignSupportIdSignGroupIdSignIdRoute:
      AuthenticatedManagementVerkehrszeichenRechercheSignSupportIdSignGroupIdSignIdRoute,
  }

const AuthenticatedManagementVerkehrszeichenRouteRouteWithChildren =
  AuthenticatedManagementVerkehrszeichenRouteRoute._addFileChildren(
    AuthenticatedManagementVerkehrszeichenRouteRouteChildren,
  )

interface AuthenticatedManagementVorgaengeRouteRouteChildren {
  AuthenticatedManagementVorgaengeIndexRoute: typeof AuthenticatedManagementVorgaengeIndexRoute
  AuthenticatedManagementVorgaengeAdminLevelIdIndexRoute: typeof AuthenticatedManagementVorgaengeAdminLevelIdIndexRoute
  AuthenticatedManagementVorgaengeRechercheIndexRoute: typeof AuthenticatedManagementVorgaengeRechercheIndexRoute
  AuthenticatedManagementVorgaengeAdminLevelIdProcessIdExaminationIdRoute: typeof AuthenticatedManagementVorgaengeAdminLevelIdProcessIdExaminationIdRoute
  AuthenticatedManagementVorgaengeAdminLevelIdProcessIdEditRoute: typeof AuthenticatedManagementVorgaengeAdminLevelIdProcessIdEditRoute
  AuthenticatedManagementVorgaengeAdminLevelIdProcessIdIndexRoute: typeof AuthenticatedManagementVorgaengeAdminLevelIdProcessIdIndexRoute
  AuthenticatedManagementVorgaengeAdminLevelIdKarteIndexRoute: typeof AuthenticatedManagementVorgaengeAdminLevelIdKarteIndexRoute
}

const AuthenticatedManagementVorgaengeRouteRouteChildren: AuthenticatedManagementVorgaengeRouteRouteChildren =
  {
    AuthenticatedManagementVorgaengeIndexRoute:
      AuthenticatedManagementVorgaengeIndexRoute,
    AuthenticatedManagementVorgaengeAdminLevelIdIndexRoute:
      AuthenticatedManagementVorgaengeAdminLevelIdIndexRoute,
    AuthenticatedManagementVorgaengeRechercheIndexRoute:
      AuthenticatedManagementVorgaengeRechercheIndexRoute,
    AuthenticatedManagementVorgaengeAdminLevelIdProcessIdExaminationIdRoute:
      AuthenticatedManagementVorgaengeAdminLevelIdProcessIdExaminationIdRoute,
    AuthenticatedManagementVorgaengeAdminLevelIdProcessIdEditRoute:
      AuthenticatedManagementVorgaengeAdminLevelIdProcessIdEditRoute,
    AuthenticatedManagementVorgaengeAdminLevelIdProcessIdIndexRoute:
      AuthenticatedManagementVorgaengeAdminLevelIdProcessIdIndexRoute,
    AuthenticatedManagementVorgaengeAdminLevelIdKarteIndexRoute:
      AuthenticatedManagementVorgaengeAdminLevelIdKarteIndexRoute,
  }

const AuthenticatedManagementVorgaengeRouteRouteWithChildren =
  AuthenticatedManagementVorgaengeRouteRoute._addFileChildren(
    AuthenticatedManagementVorgaengeRouteRouteChildren,
  )

interface AuthenticatedManagementRouteRouteChildren {
  AuthenticatedManagementAdministrationRouteRoute: typeof AuthenticatedManagementAdministrationRouteRouteWithChildren
  AuthenticatedManagementMeineOrganisationRouteRoute: typeof AuthenticatedManagementMeineOrganisationRouteRouteWithChildren
  AuthenticatedManagementVerkehrszeichenRouteRoute: typeof AuthenticatedManagementVerkehrszeichenRouteRouteWithChildren
  AuthenticatedManagementVorgaengeRouteRoute: typeof AuthenticatedManagementVorgaengeRouteRouteWithChildren
  AuthenticatedManagementProfilEditRoute: typeof AuthenticatedManagementProfilEditRoute
  AuthenticatedManagementProfilIndexRoute: typeof AuthenticatedManagementProfilIndexRoute
}

const AuthenticatedManagementRouteRouteChildren: AuthenticatedManagementRouteRouteChildren =
  {
    AuthenticatedManagementAdministrationRouteRoute:
      AuthenticatedManagementAdministrationRouteRouteWithChildren,
    AuthenticatedManagementMeineOrganisationRouteRoute:
      AuthenticatedManagementMeineOrganisationRouteRouteWithChildren,
    AuthenticatedManagementVerkehrszeichenRouteRoute:
      AuthenticatedManagementVerkehrszeichenRouteRouteWithChildren,
    AuthenticatedManagementVorgaengeRouteRoute:
      AuthenticatedManagementVorgaengeRouteRouteWithChildren,
    AuthenticatedManagementProfilEditRoute:
      AuthenticatedManagementProfilEditRoute,
    AuthenticatedManagementProfilIndexRoute:
      AuthenticatedManagementProfilIndexRoute,
  }

const AuthenticatedManagementRouteRouteWithChildren =
  AuthenticatedManagementRouteRoute._addFileChildren(
    AuthenticatedManagementRouteRouteChildren,
  )

interface AuthenticatedAnordnungRouteRouteChildren {
  AuthenticatedAnordnungProcessIdRoute: typeof AuthenticatedAnordnungProcessIdRoute
  AuthenticatedAnordnungSuccessRoute: typeof AuthenticatedAnordnungSuccessRoute
}

const AuthenticatedAnordnungRouteRouteChildren: AuthenticatedAnordnungRouteRouteChildren =
  {
    AuthenticatedAnordnungProcessIdRoute: AuthenticatedAnordnungProcessIdRoute,
    AuthenticatedAnordnungSuccessRoute: AuthenticatedAnordnungSuccessRoute,
  }

const AuthenticatedAnordnungRouteRouteWithChildren =
  AuthenticatedAnordnungRouteRoute._addFileChildren(
    AuthenticatedAnordnungRouteRouteChildren,
  )

interface AuthenticatedHilfeRouteRouteChildren {
  AuthenticatedHilfeBenutzerverwaltungRoute: typeof AuthenticatedHilfeBenutzerverwaltungRoute
  AuthenticatedHilfeDatenschnittstellenRoute: typeof AuthenticatedHilfeDatenschnittstellenRoute
  AuthenticatedHilfeFunktionsuebersichtRoute: typeof AuthenticatedHilfeFunktionsuebersichtRoute
  AuthenticatedHilfeKlickanleitungenRoute: typeof AuthenticatedHilfeKlickanleitungenRoute
  AuthenticatedHilfeOrganisationsverwaltungRoute: typeof AuthenticatedHilfeOrganisationsverwaltungRoute
  AuthenticatedHilfeReleaseNotesRoute: typeof AuthenticatedHilfeReleaseNotesRoute
  AuthenticatedHilfeVerkehrszeichenDatenmodellRoute: typeof AuthenticatedHilfeVerkehrszeichenDatenmodellRoute
  AuthenticatedHilfeVerkehrszeichenEditRoute: typeof AuthenticatedHilfeVerkehrszeichenEditRoute
  AuthenticatedHilfeVorgaengeRoute: typeof AuthenticatedHilfeVorgaengeRoute
  AuthenticatedHilfeIndexRoute: typeof AuthenticatedHilfeIndexRoute
}

const AuthenticatedHilfeRouteRouteChildren: AuthenticatedHilfeRouteRouteChildren =
  {
    AuthenticatedHilfeBenutzerverwaltungRoute:
      AuthenticatedHilfeBenutzerverwaltungRoute,
    AuthenticatedHilfeDatenschnittstellenRoute:
      AuthenticatedHilfeDatenschnittstellenRoute,
    AuthenticatedHilfeFunktionsuebersichtRoute:
      AuthenticatedHilfeFunktionsuebersichtRoute,
    AuthenticatedHilfeKlickanleitungenRoute:
      AuthenticatedHilfeKlickanleitungenRoute,
    AuthenticatedHilfeOrganisationsverwaltungRoute:
      AuthenticatedHilfeOrganisationsverwaltungRoute,
    AuthenticatedHilfeReleaseNotesRoute: AuthenticatedHilfeReleaseNotesRoute,
    AuthenticatedHilfeVerkehrszeichenDatenmodellRoute:
      AuthenticatedHilfeVerkehrszeichenDatenmodellRoute,
    AuthenticatedHilfeVerkehrszeichenEditRoute:
      AuthenticatedHilfeVerkehrszeichenEditRoute,
    AuthenticatedHilfeVorgaengeRoute: AuthenticatedHilfeVorgaengeRoute,
    AuthenticatedHilfeIndexRoute: AuthenticatedHilfeIndexRoute,
  }

const AuthenticatedHilfeRouteRouteWithChildren =
  AuthenticatedHilfeRouteRoute._addFileChildren(
    AuthenticatedHilfeRouteRouteChildren,
  )

interface AuthenticatedPruefungRouteRouteChildren {
  AuthenticatedPruefungProcessIdExaminationIdRoute: typeof AuthenticatedPruefungProcessIdExaminationIdRoute
}

const AuthenticatedPruefungRouteRouteChildren: AuthenticatedPruefungRouteRouteChildren =
  {
    AuthenticatedPruefungProcessIdExaminationIdRoute:
      AuthenticatedPruefungProcessIdExaminationIdRoute,
  }

const AuthenticatedPruefungRouteRouteWithChildren =
  AuthenticatedPruefungRouteRoute._addFileChildren(
    AuthenticatedPruefungRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedManagementRouteRoute: typeof AuthenticatedManagementRouteRouteWithChildren
  AuthenticatedAnordnungRouteRoute: typeof AuthenticatedAnordnungRouteRouteWithChildren
  AuthenticatedHilfeRouteRoute: typeof AuthenticatedHilfeRouteRouteWithChildren
  AuthenticatedPruefungRouteRoute: typeof AuthenticatedPruefungRouteRouteWithChildren
  AuthenticatedBarrierefreiheitRoute: typeof AuthenticatedBarrierefreiheitRoute
  AuthenticatedDatenschutzRoute: typeof AuthenticatedDatenschutzRoute
  AuthenticatedImpressumRoute: typeof AuthenticatedImpressumRoute
  AuthenticatedKontaktRoute: typeof AuthenticatedKontaktRoute
  AuthenticatedNutzungsbedingungenRoute: typeof AuthenticatedNutzungsbedingungenRoute
  AuthenticatedRegistrierungRoute: typeof AuthenticatedRegistrierungRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedManagementRouteRoute:
    AuthenticatedManagementRouteRouteWithChildren,
  AuthenticatedAnordnungRouteRoute:
    AuthenticatedAnordnungRouteRouteWithChildren,
  AuthenticatedHilfeRouteRoute: AuthenticatedHilfeRouteRouteWithChildren,
  AuthenticatedPruefungRouteRoute: AuthenticatedPruefungRouteRouteWithChildren,
  AuthenticatedBarrierefreiheitRoute: AuthenticatedBarrierefreiheitRoute,
  AuthenticatedDatenschutzRoute: AuthenticatedDatenschutzRoute,
  AuthenticatedImpressumRoute: AuthenticatedImpressumRoute,
  AuthenticatedKontaktRoute: AuthenticatedKontaktRoute,
  AuthenticatedNutzungsbedingungenRoute: AuthenticatedNutzungsbedingungenRoute,
  AuthenticatedRegistrierungRoute: AuthenticatedRegistrierungRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
